/* eslint-disable */
const iX = function (N, V) {
  const w = Object.keys(N);
  if (Object.getOwnPropertySymbols) {
    let q = Object.getOwnPropertySymbols(N);
    V &&
      (q = q.filter((M) => {
        return Object.getOwnPropertyDescriptor(N, M).enumerable;
      })),
      w.push.apply(w, q);
  }
  return w;
};
const sX = function (N) {
  for (let V = 1; V < arguments.length; V++) {
    var w = arguments[V] != null ? arguments[V] : {};
    V % 2
      ? iX(Object(w), !0).forEach((q) => {
          F(N, q, w[q]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(w))
        : iX(Object(w)).forEach((q) => {
            Object.defineProperty(N, q, Object.getOwnPropertyDescriptor(w, q));
          });
  }
  return N;
};
const nX = function (N, V) {
  let w =
    (typeof Symbol !== "undefined" && N[Symbol.iterator]) || N["@@iterator"];
  if (!w) {
    if (
      Array.isArray(N) ||
      (w = tX(N)) ||
      (V && N && typeof N.length === "number")
    ) {
      if (w) N = w;
      let q = 0;
      const M = function d() {};
      return {
        s: M,
        n: function d() {
          if (q >= N.length) return { done: !0 };
          return { done: !1, value: N[q++] };
        },
        e: function d(e) {
          throw e;
        },
        f: M,
      };
    }
    throw new TypeError(
      "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
    );
  }
  let u = !0;
  let a = !1;
  let n;
  return {
    s: function d() {
      w = w.call(N);
    },
    n: function d() {
      const e = w.next();
      return (u = e.done), e;
    },
    e: function d(e) {
      (a = !0), (n = e);
    },
    f: function d() {
      try {
        if (!u && w.return != null) w.return();
      } finally {
        if (a) throw n;
      }
    },
  };
};
const P = function (N, V, w) {
  return (
    (V = UK(V)),
    ej(
      N,
      aX() ? Reflect.construct(V, w || [], UK(N).constructor) : V.apply(N, w),
    )
  );
};
var ej = function (N, V) {
  if (V && (FG(V) === "object" || typeof V === "function")) return V;
  else if (V !== void 0)
    throw new TypeError(
      "Derived constructors may only return object or undefined",
    );
  return C(N);
};
var C = function (N) {
  if (N === void 0)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called",
    );
  return N;
};
var aX = function () {
  try {
    var N = !Boolean.prototype.valueOf.call(
      Reflect.construct(Boolean, [], () => {}),
    );
  } catch (V) {}
  return (aX = function V() {
    return !!N;
  })();
};
var UK = function (N) {
  return (
    (UK = Object.setPrototypeOf
      ? Object.getPrototypeOf.bind()
      : function V(w) {
          return w.__proto__ || Object.getPrototypeOf(w);
        }),
    UK(N)
  );
};
const D = function (N, V) {
  if (typeof V !== "function" && V !== null)
    throw new TypeError("Super expression must either be null or a function");
  if (
    ((N.prototype = Object.create(V && V.prototype, {
      constructor: { value: N, writable: !0, configurable: !0 },
    })),
    Object.defineProperty(N, "prototype", { writable: !1 }),
    V)
  )
    vK(N, V);
};
var vK = function (N, V) {
  return (
    (vK = Object.setPrototypeOf
      ? Object.setPrototypeOf.bind()
      : function w(q, M) {
          return (q.__proto__ = M), q;
        }),
    vK(N, V)
  );
};
const L = function (N, V) {
  if (!(N instanceof V))
    throw new TypeError("Cannot call a class as a function");
};
const rX = function (N, V) {
  for (let w = 0; w < V.length; w++) {
    const q = V[w];
    if (
      ((q.enumerable = q.enumerable || !1), (q.configurable = !0), "value" in q)
    )
      q.writable = !0;
    Object.defineProperty(N, eX(q.key), q);
  }
};
const $ = function (N, V, w) {
  if (V) rX(N.prototype, V);
  if (w) rX(N, w);
  return Object.defineProperty(N, "prototype", { writable: !1 }), N;
};
var F = function (N, V, w) {
  if (((V = eX(V)), V in N))
    Object.defineProperty(N, V, {
      value: w,
      enumerable: !0,
      configurable: !0,
      writable: !0,
    });
  else N[V] = w;
  return N;
};
var eX = function (N) {
  const V = tj(N, "string");
  return FG(V) == "symbol" ? V : String(V);
};
var tj = function (N, V) {
  if (FG(N) != "object" || !N) return N;
  const w = N[Symbol.toPrimitive];
  if (w !== void 0) {
    const q = w.call(N, V || "default");
    if (FG(q) != "object") return q;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (V === "string" ? String : Number)(N);
};
const SG = function (N, V) {
  return XJ(N) || KJ(N, V) || tX(N, V) || GJ();
};
var GJ = function () {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
};
var tX = function (N, V) {
  if (!N) return;
  if (typeof N === "string") return oX(N, V);
  let w = Object.prototype.toString.call(N).slice(8, -1);
  if (w === "Object" && N.constructor) w = N.constructor.name;
  if (w === "Map" || w === "Set") return Array.from(N);
  if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w))
    return oX(N, V);
};
var oX = function (N, V) {
  if (V == null || V > N.length) V = N.length;
  for (var w = 0, q = new Array(V); w < V; w++) q[w] = N[w];
  return q;
};
var KJ = function (N, V) {
  let w =
    N == null
      ? null
      : (typeof Symbol !== "undefined" && N[Symbol.iterator]) ||
        N["@@iterator"];
  if (w != null) {
    let q;
    let M;
    let u;
    let a;
    const n = [];
    let d = !0;
    let e = !1;
    try {
      if (((u = (w = w.call(N)).next), V === 0)) {
        if (Object(w) !== w) return;
        d = !1;
      } else
        for (
          ;
          !(d = (q = u.call(w)).done) && (n.push(q.value), n.length !== V);
          d = !0
        );
    } catch (QG) {
      (e = !0), (M = QG);
    } finally {
      try {
        if (!d && w.return != null && ((a = w.return()), Object(a) !== a))
          return;
      } finally {
        if (e) throw M;
      }
    }
    return n;
  }
};
var XJ = function (N) {
  if (Array.isArray(N)) return N;
};
var FG = function (N) {
  return (
    (FG =
      typeof Symbol === "function" && typeof Symbol.iterator === "symbol"
        ? function (V) {
            return typeof V;
          }
        : function (V) {
            return V &&
              typeof Symbol === "function" &&
              V.constructor === Symbol &&
              V !== Symbol.prototype
              ? "symbol"
              : typeof V;
          }),
    FG(N)
  );
};
(function () {
  const N = Object.defineProperty;
  const V = function G(X, K) {
    for (var B in K)
      N(X, B, {
        get: K[B],
        enumerable: !0,
        configurable: !0,
        set: function U(Z) {
          return (K[B] = function () {
            return Z;
          });
        },
      });
  };
  const w = {};
  V(w, {
    yearsToQuarters: function G() {
      return rj;
    },
    yearsToMonths: function G() {
      return nj;
    },
    yearsToDays: function G() {
      return sj;
    },
    weeksToDays: function G() {
      return ij;
    },
    transpose: function G() {
      return IX;
    },
    toDate: function G() {
      return q;
    },
    subYears: function G() {
      return dj;
    },
    subWeeks: function G() {
      return lj;
    },
    subSeconds: function G() {
      return _j;
    },
    subQuarters: function G() {
      return uj;
    },
    subMonths: function G() {
      return gX;
    },
    subMinutes: function G() {
      return pj;
    },
    subMilliseconds: function G() {
      return fj;
    },
    subISOWeekYears: function G() {
      return eK;
    },
    subHours: function G() {
      return cj;
    },
    subDays: function G() {
      return tG;
    },
    subBusinessDays: function G() {
      return gj;
    },
    sub: function G() {
      return mj;
    },
    startOfYesterday: function G() {
      return hj;
    },
    startOfYear: function G() {
      return FK;
    },
    startOfWeekYear: function G() {
      return nG;
    },
    startOfWeek: function G() {
      return f;
    },
    startOfTomorrow: function G() {
      return kj;
    },
    startOfToday: function G() {
      return yj;
    },
    startOfSecond: function G() {
      return RK;
    },
    startOfQuarter: function G() {
      return wG;
    },
    startOfMonth: function G() {
      return iG;
    },
    startOfMinute: function G() {
      return dG;
    },
    startOfISOWeekYear: function G() {
      return xG;
    },
    startOfISOWeek: function G() {
      return GG;
    },
    startOfHour: function G() {
      return zK;
    },
    startOfDecade: function G() {
      return Sj;
    },
    startOfDay: function G() {
      return MG;
    },
    setYear: function G() {
      return Oj;
    },
    setWeekYear: function G() {
      return vj;
    },
    setWeek: function G() {
      return zX;
    },
    setSeconds: function G() {
      return Dj;
    },
    setQuarter: function G() {
      return Pj;
    },
    setMonth: function G() {
      return $K;
    },
    setMinutes: function G() {
      return $j;
    },
    setMilliseconds: function G() {
      return Lj;
    },
    setISOWeekYear: function G() {
      return _K;
    },
    setISOWeek: function G() {
      return WX;
    },
    setISODay: function G() {
      return RX;
    },
    setHours: function G() {
      return Rj;
    },
    setDefaultOptions: function G() {
      return Wj;
    },
    setDayOfYear: function G() {
      return zj;
    },
    setDay: function G() {
      return eG;
    },
    setDate: function G() {
      return Tj;
    },
    set: function G() {
      return Yj;
    },
    secondsToMinutes: function G() {
      return Mj;
    },
    secondsToMilliseconds: function G() {
      return bj;
    },
    secondsToHours: function G() {
      return Ij;
    },
    roundToNearestMinutes: function G() {
      return wj;
    },
    roundToNearestHours: function G() {
      return Cj;
    },
    quartersToYears: function G() {
      return Fj;
    },
    quartersToMonths: function G() {
      return Ej;
    },
    previousWednesday: function G() {
      return Vj;
    },
    previousTuesday: function G() {
      return Nj;
    },
    previousThursday: function G() {
      return Aj;
    },
    previousSunday: function G() {
      return xj;
    },
    previousSaturday: function G() {
      return Hj;
    },
    previousMonday: function G() {
      return Qj;
    },
    previousFriday: function G() {
      return qj;
    },
    previousDay: function G() {
      return VG;
    },
    parsers: function G() {
      return LX;
    },
    parseJSON: function G() {
      return Jj;
    },
    parseISO: function G() {
      return dZ;
    },
    parse: function G() {
      return $X;
    },
    nextWednesday: function G() {
      return lZ;
    },
    nextTuesday: function G() {
      return _Z;
    },
    nextThursday: function G() {
      return uZ;
    },
    nextSunday: function G() {
      return pZ;
    },
    nextSaturday: function G() {
      return fZ;
    },
    nextMonday: function G() {
      return cZ;
    },
    nextFriday: function G() {
      return gZ;
    },
    nextDay: function G() {
      return NG;
    },
    monthsToYears: function G() {
      return mZ;
    },
    monthsToQuarters: function G() {
      return hZ;
    },
    minutesToSeconds: function G() {
      return kZ;
    },
    minutesToMilliseconds: function G() {
      return yZ;
    },
    minutesToHours: function G() {
      return SZ;
    },
    min: function G() {
      return nK;
    },
    millisecondsToSeconds: function G() {
      return OZ;
    },
    millisecondsToMinutes: function G() {
      return vZ;
    },
    millisecondsToHours: function G() {
      return DZ;
    },
    milliseconds: function G() {
      return PZ;
    },
    max: function G() {
      return sK;
    },
    longFormatters: function G() {
      return rG;
    },
    lightFormatters: function G() {
      return BG;
    },
    lightFormat: function G() {
      return TZ;
    },
    lastDayOfYear: function G() {
      return YZ;
    },
    lastDayOfWeek: function G() {
      return hX;
    },
    lastDayOfQuarter: function G() {
      return MZ;
    },
    lastDayOfMonth: function G() {
      return wX;
    },
    lastDayOfISOWeekYear: function G() {
      return bZ;
    },
    lastDayOfISOWeek: function G() {
      return IZ;
    },
    lastDayOfDecade: function G() {
      return wZ;
    },
    isYesterday: function G() {
      return CZ;
    },
    isWithinInterval: function G() {
      return FZ;
    },
    isWeekend: function G() {
      return QG;
    },
    isWednesday: function G() {
      return EZ;
    },
    isValid: function G() {
      return qG;
    },
    isTuesday: function G() {
      return VZ;
    },
    isTomorrow: function G() {
      return NZ;
    },
    isToday: function G() {
      return AZ;
    },
    isThursday: function G() {
      return xZ;
    },
    isThisYear: function G() {
      return HZ;
    },
    isThisWeek: function G() {
      return QZ;
    },
    isThisSecond: function G() {
      return qZ;
    },
    isThisQuarter: function G() {
      return JZ;
    },
    isThisMonth: function G() {
      return jZ;
    },
    isThisMinute: function G() {
      return ZZ;
    },
    isThisISOWeek: function G() {
      return UZ;
    },
    isThisHour: function G() {
      return BZ;
    },
    isSunday: function G() {
      return e;
    },
    isSaturday: function G() {
      return d;
    },
    isSameYear: function G() {
      return kX;
    },
    isSameWeek: function G() {
      return WK;
    },
    isSameSecond: function G() {
      return yX;
    },
    isSameQuarter: function G() {
      return SX;
    },
    isSameMonth: function G() {
      return OX;
    },
    isSameMinute: function G() {
      return vX;
    },
    isSameISOWeekYear: function G() {
      return XZ;
    },
    isSameISOWeek: function G() {
      return DX;
    },
    isSameHour: function G() {
      return PX;
    },
    isSameDay: function G() {
      return $G;
    },
    isPast: function G() {
      return KZ;
    },
    isMonday: function G() {
      return GZ;
    },
    isMatch: function G() {
      return tU;
    },
    isLeapYear: function G() {
      return EX;
    },
    isLastDayOfMonth: function G() {
      return tK;
    },
    isFuture: function G() {
      return QU;
    },
    isFriday: function G() {
      return qU;
    },
    isFirstDayOfMonth: function G() {
      return JU;
    },
    isExists: function G() {
      return jU;
    },
    isEqual: function G() {
      return ZU;
    },
    isDate: function G() {
      return rK;
    },
    isBefore: function G() {
      return UU;
    },
    isAfter: function G() {
      return BU;
    },
    intlFormatDistance: function G() {
      return XU;
    },
    intlFormat: function G() {
      return GU;
    },
    intervalToDuration: function G() {
      return tB;
    },
    interval: function G() {
      return eB;
    },
    hoursToSeconds: function G() {
      return aB;
    },
    hoursToMinutes: function G() {
      return oB;
    },
    hoursToMilliseconds: function G() {
      return rB;
    },
    getYear: function G() {
      return nB;
    },
    getWeeksInMonth: function G() {
      return sB;
    },
    getWeekYear: function G() {
      return sG;
    },
    getWeekOfMonth: function G() {
      return iB;
    },
    getWeek: function G() {
      return IK;
    },
    getUnixTime: function G() {
      return dB;
    },
    getTime: function G() {
      return lB;
    },
    getSeconds: function G() {
      return _B;
    },
    getQuarter: function G() {
      return xK;
    },
    getOverlappingDaysInIntervals: function G() {
      return uB;
    },
    getMonth: function G() {
      return pB;
    },
    getMinutes: function G() {
      return fB;
    },
    getMilliseconds: function G() {
      return cB;
    },
    getISOWeeksInYear: function G() {
      return gB;
    },
    getISOWeekYear: function G() {
      return HG;
    },
    getISOWeek: function G() {
      return wK;
    },
    getISODay: function G() {
      return CX;
    },
    getHours: function G() {
      return mB;
    },
    getDefaultOptions: function G() {
      return FX;
    },
    getDecade: function G() {
      return hB;
    },
    getDaysInYear: function G() {
      return kB;
    },
    getDaysInMonth: function G() {
      return VX;
    },
    getDayOfYear: function G() {
      return UX;
    },
    getDay: function G() {
      return oG;
    },
    getDate: function G() {
      return NX;
    },
    fromUnixTime: function G() {
      return yB;
    },
    formatters: function G() {
      return bK;
    },
    formatRelative: function G() {
      return SB;
    },
    formatRFC7231: function G() {
      return DB;
    },
    formatRFC3339: function G() {
      return PB;
    },
    formatISODuration: function G() {
      return $B;
    },
    formatISO9075: function G() {
      return LB;
    },
    formatISO: function G() {
      return RB;
    },
    formatDuration: function G() {
      return zB;
    },
    formatDistanceToNowStrict: function G() {
      return TB;
    },
    formatDistanceToNow: function G() {
      return YB;
    },
    formatDistanceStrict: function G() {
      return AX;
    },
    formatDistance: function G() {
      return xX;
    },
    formatDate: function G() {
      return YK;
    },
    format: function G() {
      return YK;
    },
    endOfYesterday: function G() {
      return O0;
    },
    endOfYear: function G() {
      return XX;
    },
    endOfWeek: function G() {
      return BX;
    },
    endOfTomorrow: function G() {
      return v0;
    },
    endOfToday: function G() {
      return D0;
    },
    endOfSecond: function G() {
      return P0;
    },
    endOfQuarter: function G() {
      return $0;
    },
    endOfMonth: function G() {
      return VK;
    },
    endOfMinute: function G() {
      return L0;
    },
    endOfISOWeekYear: function G() {
      return R0;
    },
    endOfISOWeek: function G() {
      return W0;
    },
    endOfHour: function G() {
      return z0;
    },
    endOfDecade: function G() {
      return T0;
    },
    endOfDay: function G() {
      return NK;
    },
    eachYearOfInterval: function G() {
      return Y0;
    },
    eachWeekendOfYear: function G() {
      return M0;
    },
    eachWeekendOfMonth: function G() {
      return b0;
    },
    eachWeekendOfInterval: function G() {
      return EK;
    },
    eachWeekOfInterval: function G() {
      return I0;
    },
    eachQuarterOfInterval: function G() {
      return w0;
    },
    eachMonthOfInterval: function G() {
      return C0;
    },
    eachMinuteOfInterval: function G() {
      return F0;
    },
    eachHourOfInterval: function G() {
      return E0;
    },
    eachDayOfInterval: function G() {
      return KX;
    },
    differenceInYears: function G() {
      return GX;
    },
    differenceInWeeks: function G() {
      return V0;
    },
    differenceInSeconds: function G() {
      return YG;
    },
    differenceInQuarters: function G() {
      return N0;
    },
    differenceInMonths: function G() {
      return lG;
    },
    differenceInMinutes: function G() {
      return _G;
    },
    differenceInMilliseconds: function G() {
      return pG;
    },
    differenceInISOWeekYears: function G() {
      return A0;
    },
    differenceInHours: function G() {
      return uG;
    },
    differenceInDays: function G() {
      return AK;
    },
    differenceInCalendarYears: function G() {
      return PG;
    },
    differenceInCalendarWeeks: function G() {
      return fG;
    },
    differenceInCalendarQuarters: function G() {
      return cG;
    },
    differenceInCalendarMonths: function G() {
      return gG;
    },
    differenceInCalendarISOWeeks: function G() {
      return x0;
    },
    differenceInCalendarISOWeekYears: function G() {
      return oK;
    },
    differenceInCalendarDays: function G() {
      return KG;
    },
    differenceInBusinessDays: function G() {
      return H0;
    },
    daysToWeeks: function G() {
      return Q0;
    },
    constructNow: function G() {
      return s;
    },
    constructFrom: function G() {
      return M;
    },
    compareDesc: function G() {
      return q0;
    },
    compareAsc: function G() {
      return XG;
    },
    closestTo: function G() {
      return J0;
    },
    closestIndexTo: function G() {
      return j0;
    },
    clamp: function G() {
      return Z0;
    },
    areIntervalsOverlapping: function G() {
      return U0;
    },
    addYears: function G() {
      return iK;
    },
    addWeeks: function G() {
      return mG;
    },
    addSeconds: function G() {
      return dK;
    },
    addQuarters: function G() {
      return HK;
    },
    addMonths: function G() {
      return a;
    },
    addMinutes: function G() {
      return QK;
    },
    addMilliseconds: function G() {
      return RG;
    },
    addISOWeekYears: function G() {
      return lK;
    },
    addHours: function G() {
      return qK;
    },
    addDays: function G() {
      return u;
    },
    addBusinessDays: function G() {
      return OK;
    },
    add: function G() {
      return n;
    },
  });
  function q(G) {
    const X = Object.prototype.toString.call(G);
    if (G instanceof Date || (FG(G) === "object" && X === "[object Date]"))
      return new G.constructor(+G);
    else if (
      typeof G === "number" ||
      X === "[object Number]" ||
      typeof G === "string" ||
      X === "[object String]"
    )
      return new Date(G);
    else return new Date(NaN);
  }
  function M(G, X) {
    if (G instanceof Date) return new G.constructor(X);
    else return new Date(X);
  }
  function u(G, X) {
    const K = q(G);
    if (isNaN(X)) return M(G, NaN);
    if (!X) return K;
    return K.setDate(K.getDate() + X), K;
  }
  function a(G, X) {
    const K = q(G);
    if (isNaN(X)) return M(G, NaN);
    if (!X) return K;
    const B = K.getDate();
    const U = M(G, K.getTime());
    U.setMonth(K.getMonth() + X + 1, 0);
    const Z = U.getDate();
    if (B >= Z) return U;
    else return K.setFullYear(U.getFullYear(), U.getMonth(), B), K;
  }
  function n(G, X) {
    const K = X.years;
    const B = K === void 0 ? 0 : K;
    const U = X.months;
    const Z = U === void 0 ? 0 : U;
    const j = X.weeks;
    const J = j === void 0 ? 0 : j;
    const Q = X.days;
    const H = Q === void 0 ? 0 : Q;
    const x = X.hours;
    const A = x === void 0 ? 0 : x;
    const E = X.minutes;
    const T = E === void 0 ? 0 : E;
    const I = X.seconds;
    const z = I === void 0 ? 0 : I;
    const Y = q(G);
    const W = Z || B ? a(Y, Z + B * 12) : Y;
    const R = H || J ? u(W, H + J * 7) : W;
    const m = T + A * 60;
    const l = z + m * 60;
    const r = l * 1000;
    const o = M(G, R.getTime() + r);
    return o;
  }
  function d(G) {
    return q(G).getDay() === 6;
  }
  function e(G) {
    return q(G).getDay() === 0;
  }
  function QG(G) {
    const X = q(G).getDay();
    return X === 0 || X === 6;
  }
  function OK(G, X) {
    const K = q(G);
    const B = QG(K);
    if (isNaN(X)) return M(G, NaN);
    const U = K.getHours();
    const Z = X < 0 ? -1 : 1;
    const j = Math.trunc(X / 5);
    K.setDate(K.getDate() + j * 7);
    let J = Math.abs(X % 5);
    while (J > 0) if ((K.setDate(K.getDate() + Z), !QG(K))) J -= 1;
    if (B && QG(K) && X !== 0) {
      if (d(K)) K.setDate(K.getDate() + (Z < 0 ? 2 : -1));
      if (e(K)) K.setDate(K.getDate() + (Z < 0 ? 1 : -2));
    }
    return K.setHours(U), K;
  }
  function RG(G, X) {
    const K = +q(G);
    return M(G, K + X);
  }
  const SK = 7;
  const yG = 365.2425;
  const G0 = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
  const BJ = -G0;
  const LG = 604800000;
  const yK = 86400000;
  const JG = 60000;
  const CG = 3600000;
  const ZK = 1000;
  const kK = 525600;
  const bG = 43200;
  const kG = 1440;
  const hK = 60;
  const mK = 3;
  const gK = 12;
  const cK = 4;
  const hG = 3600;
  const jK = 60;
  const JK = hG * 24;
  const K0 = JK * 7;
  const fK = JK * yG;
  const pK = fK / 12;
  const X0 = pK * 3;
  function qK(G, X) {
    return RG(G, X * CG);
  }
  function _() {
    return uK;
  }
  function B0(G) {
    uK = G;
  }
  var uK = {};
  function f(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    let J;
    const Q = _();
    const H =
      (K =
        (B =
          (U =
            (Z = X === null || X === void 0 ? void 0 : X.weekStartsOn) !==
              null && Z !== void 0
              ? Z
              : X === null ||
                  X === void 0 ||
                  (j = X.locale) === null ||
                  j === void 0 ||
                  (j = j.options) === null ||
                  j === void 0
                ? void 0
                : j.weekStartsOn) !== null && U !== void 0
            ? U
            : Q.weekStartsOn) !== null && B !== void 0
          ? B
          : (J = Q.locale) === null ||
              J === void 0 ||
              (J = J.options) === null ||
              J === void 0
            ? void 0
            : J.weekStartsOn) !== null && K !== void 0
        ? K
        : 0;
    const x = q(G);
    const A = x.getDay();
    const E = (A < H ? 7 : 0) + A - H;
    return x.setDate(x.getDate() - E), x.setHours(0, 0, 0, 0), x;
  }
  function GG(G) {
    return f(G, { weekStartsOn: 1 });
  }
  function HG(G) {
    const X = q(G);
    const K = X.getFullYear();
    const B = M(G, 0);
    B.setFullYear(K + 1, 0, 4), B.setHours(0, 0, 0, 0);
    const U = GG(B);
    const Z = M(G, 0);
    Z.setFullYear(K, 0, 4), Z.setHours(0, 0, 0, 0);
    const j = GG(Z);
    if (X.getTime() >= U.getTime()) return K + 1;
    else if (X.getTime() >= j.getTime()) return K;
    else return K - 1;
  }
  function MG(G) {
    const X = q(G);
    return X.setHours(0, 0, 0, 0), X;
  }
  function i(G) {
    const X = q(G);
    const K = new Date(
      Date.UTC(
        X.getFullYear(),
        X.getMonth(),
        X.getDate(),
        X.getHours(),
        X.getMinutes(),
        X.getSeconds(),
        X.getMilliseconds(),
      ),
    );
    return K.setUTCFullYear(X.getFullYear()), +G - +K;
  }
  function KG(G, X) {
    const K = MG(G);
    const B = MG(X);
    const U = +K - i(K);
    const Z = +B - i(B);
    return Math.round((U - Z) / yK);
  }
  function xG(G) {
    const X = HG(G);
    const K = M(G, 0);
    return K.setFullYear(X, 0, 4), K.setHours(0, 0, 0, 0), GG(K);
  }
  function _K(G, X) {
    let K = q(G);
    const B = KG(K, xG(K));
    const U = M(G, 0);
    return (
      U.setFullYear(X, 0, 4),
      U.setHours(0, 0, 0, 0),
      (K = xG(U)),
      K.setDate(K.getDate() + B),
      K
    );
  }
  function lK(G, X) {
    return _K(G, HG(G) + X);
  }
  function QK(G, X) {
    return RG(G, X * JG);
  }
  function HK(G, X) {
    const K = X * 3;
    return a(G, K);
  }
  function dK(G, X) {
    return RG(G, X * 1000);
  }
  function mG(G, X) {
    const K = X * 7;
    return u(G, K);
  }
  function iK(G, X) {
    return a(G, X * 12);
  }
  function U0(G, X, K) {
    const B = [+q(G.start), +q(G.end)].sort((A, E) => {
      return A - E;
    });
    const U = SG(B, 2);
    const Z = U[0];
    const j = U[1];
    const J = [+q(X.start), +q(X.end)].sort((A, E) => {
      return A - E;
    });
    const Q = SG(J, 2);
    const H = Q[0];
    const x = Q[1];
    if (K !== null && K !== void 0 && K.inclusive) return Z <= x && H <= j;
    return Z < x && H < j;
  }
  function sK(G) {
    let X;
    return (
      G.forEach((K) => {
        const B = q(K);
        if (X === void 0 || X < B || isNaN(Number(B))) X = B;
      }),
      X || new Date(NaN)
    );
  }
  function nK(G) {
    let X;
    return (
      G.forEach((K) => {
        const B = q(K);
        if (!X || X > B || isNaN(+B)) X = B;
      }),
      X || new Date(NaN)
    );
  }
  function Z0(G, X) {
    return nK([sK([G, X.start]), X.end]);
  }
  function j0(G, X) {
    const K = q(G);
    if (isNaN(Number(K))) return NaN;
    const B = K.getTime();
    let U;
    let Z;
    return (
      X.forEach((j, J) => {
        const Q = q(j);
        if (isNaN(Number(Q))) {
          (U = NaN), (Z = NaN);
          return;
        }
        const H = Math.abs(B - Q.getTime());
        if (U == null || H < Z) (U = J), (Z = H);
      }),
      U
    );
  }
  function J0(G, X) {
    const K = q(G);
    if (isNaN(Number(K))) return M(G, NaN);
    const B = K.getTime();
    let U;
    let Z;
    return (
      X.forEach((j) => {
        const J = q(j);
        if (isNaN(Number(J))) {
          (U = M(G, NaN)), (Z = NaN);
          return;
        }
        const Q = Math.abs(B - J.getTime());
        if (U == null || Q < Z) (U = J), (Z = Q);
      }),
      U
    );
  }
  function XG(G, X) {
    const K = q(G);
    const B = q(X);
    const U = K.getTime() - B.getTime();
    if (U < 0) return -1;
    else if (U > 0) return 1;
    else return U;
  }
  function q0(G, X) {
    const K = q(G);
    const B = q(X);
    const U = K.getTime() - B.getTime();
    if (U > 0) return -1;
    else if (U < 0) return 1;
    else return U;
  }
  function s(G) {
    return M(G, Date.now());
  }
  function Q0(G) {
    const X = G / SK;
    const K = Math.trunc(X);
    return K === 0 ? 0 : K;
  }
  function $G(G, X) {
    const K = MG(G);
    const B = MG(X);
    return +K === +B;
  }
  function rK(G) {
    return (
      G instanceof Date ||
      (FG(G) === "object" &&
        Object.prototype.toString.call(G) === "[object Date]")
    );
  }
  function qG(G) {
    if (!rK(G) && typeof G !== "number") return !1;
    const X = q(G);
    return !isNaN(Number(X));
  }
  function H0(G, X) {
    const K = q(G);
    let B = q(X);
    if (!qG(K) || !qG(B)) return NaN;
    const U = KG(K, B);
    const Z = U < 0 ? -1 : 1;
    const j = Math.trunc(U / 7);
    let J = j * 5;
    B = u(B, j * 7);
    while (!$G(K, B)) (J += QG(B) ? 0 : Z), (B = u(B, Z));
    return J === 0 ? 0 : J;
  }
  function oK(G, X) {
    return HG(G) - HG(X);
  }
  function x0(G, X) {
    const K = GG(G);
    const B = GG(X);
    const U = +K - i(K);
    const Z = +B - i(B);
    return Math.round((U - Z) / LG);
  }
  function gG(G, X) {
    const K = q(G);
    const B = q(X);
    const U = K.getFullYear() - B.getFullYear();
    const Z = K.getMonth() - B.getMonth();
    return U * 12 + Z;
  }
  function xK(G) {
    const X = q(G);
    const K = Math.trunc(X.getMonth() / 3) + 1;
    return K;
  }
  function cG(G, X) {
    const K = q(G);
    const B = q(X);
    const U = K.getFullYear() - B.getFullYear();
    const Z = xK(K) - xK(B);
    return U * 4 + Z;
  }
  function fG(G, X, K) {
    const B = f(G, K);
    const U = f(X, K);
    const Z = +B - i(B);
    const j = +U - i(U);
    return Math.round((Z - j) / LG);
  }
  function PG(G, X) {
    const K = q(G);
    const B = q(X);
    return K.getFullYear() - B.getFullYear();
  }
  function AK(G, X) {
    const K = q(G);
    const B = q(X);
    const U = aK(K, B);
    const Z = Math.abs(KG(K, B));
    K.setDate(K.getDate() - U * Z);
    const j = Number(aK(K, B) === -U);
    const J = U * (Z - j);
    return J === 0 ? 0 : J;
  }
  var aK = function G(X, K) {
    const B =
      X.getFullYear() - K.getFullYear() ||
      X.getMonth() - K.getMonth() ||
      X.getDate() - K.getDate() ||
      X.getHours() - K.getHours() ||
      X.getMinutes() - K.getMinutes() ||
      X.getSeconds() - K.getSeconds() ||
      X.getMilliseconds() - K.getMilliseconds();
    if (B < 0) return -1;
    else if (B > 0) return 1;
    else return B;
  };
  function AG(G) {
    return function (X) {
      const K = G ? Math[G] : Math.trunc;
      const B = K(X);
      return B === 0 ? 0 : B;
    };
  }
  function pG(G, X) {
    return +q(G) - +q(X);
  }
  function uG(G, X, K) {
    const B = pG(G, X) / CG;
    return AG(K === null || K === void 0 ? void 0 : K.roundingMethod)(B);
  }
  function eK(G, X) {
    return lK(G, -X);
  }
  function A0(G, X) {
    let K = q(G);
    const B = q(X);
    const U = XG(K, B);
    const Z = Math.abs(oK(K, B));
    K = eK(K, U * Z);
    const j = Number(XG(K, B) === -U);
    const J = U * (Z - j);
    return J === 0 ? 0 : J;
  }
  function _G(G, X, K) {
    const B = pG(G, X) / JG;
    return AG(K === null || K === void 0 ? void 0 : K.roundingMethod)(B);
  }
  function NK(G) {
    const X = q(G);
    return X.setHours(23, 59, 59, 999), X;
  }
  function VK(G) {
    const X = q(G);
    const K = X.getMonth();
    return (
      X.setFullYear(X.getFullYear(), K + 1, 0), X.setHours(23, 59, 59, 999), X
    );
  }
  function tK(G) {
    const X = q(G);
    return +NK(X) === +VK(X);
  }
  function lG(G, X) {
    const K = q(G);
    const B = q(X);
    const U = XG(K, B);
    const Z = Math.abs(gG(K, B));
    let j;
    if (Z < 1) j = 0;
    else {
      if (K.getMonth() === 1 && K.getDate() > 27) K.setDate(30);
      K.setMonth(K.getMonth() - U * Z);
      let J = XG(K, B) === -U;
      if (tK(q(G)) && Z === 1 && XG(G, B) === 1) J = !1;
      j = U * (Z - Number(J));
    }
    return j === 0 ? 0 : j;
  }
  function N0(G, X, K) {
    const B = lG(G, X) / 3;
    return AG(K === null || K === void 0 ? void 0 : K.roundingMethod)(B);
  }
  function YG(G, X, K) {
    const B = pG(G, X) / 1000;
    return AG(K === null || K === void 0 ? void 0 : K.roundingMethod)(B);
  }
  function V0(G, X, K) {
    const B = AK(G, X) / 7;
    return AG(K === null || K === void 0 ? void 0 : K.roundingMethod)(B);
  }
  function GX(G, X) {
    const K = q(G);
    const B = q(X);
    const U = XG(K, B);
    const Z = Math.abs(PG(K, B));
    K.setFullYear(1584), B.setFullYear(1584);
    const j = XG(K, B) === -U;
    const J = U * (Z - +j);
    return J === 0 ? 0 : J;
  }
  function KX(G, X) {
    let K;
    const B = q(G.start);
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? +B : +U;
    const J = Z ? U : B;
    J.setHours(0, 0, 0, 0);
    let Q =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!Q) return [];
    if (Q < 0) (Q = -Q), (Z = !Z);
    const H = [];
    while (+J <= j)
      H.push(q(J)), J.setDate(J.getDate() + Q), J.setHours(0, 0, 0, 0);
    return Z ? H.reverse() : H;
  }
  function E0(G, X) {
    let K;
    const B = q(G.start);
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? +B : +U;
    let J = Z ? U : B;
    J.setMinutes(0, 0, 0);
    let Q =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!Q) return [];
    if (Q < 0) (Q = -Q), (Z = !Z);
    const H = [];
    while (+J <= j) H.push(q(J)), (J = qK(J, Q));
    return Z ? H.reverse() : H;
  }
  function dG(G) {
    const X = q(G);
    return X.setSeconds(0, 0), X;
  }
  function F0(G, X) {
    let K;
    const B = dG(q(G.start));
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? +B : +U;
    let J = Z ? U : B;
    let Q =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!Q) return [];
    if (Q < 0) (Q = -Q), (Z = !Z);
    const H = [];
    while (+J <= j) H.push(q(J)), (J = QK(J, Q));
    return Z ? H.reverse() : H;
  }
  function C0(G, X) {
    let K;
    const B = q(G.start);
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? +B : +U;
    const J = Z ? U : B;
    J.setHours(0, 0, 0, 0), J.setDate(1);
    let Q =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!Q) return [];
    if (Q < 0) (Q = -Q), (Z = !Z);
    const H = [];
    while (+J <= j) H.push(q(J)), J.setMonth(J.getMonth() + Q);
    return Z ? H.reverse() : H;
  }
  function wG(G) {
    const X = q(G);
    const K = X.getMonth();
    const B = K - (K % 3);
    return X.setMonth(B, 1), X.setHours(0, 0, 0, 0), X;
  }
  function w0(G, X) {
    let K;
    const B = q(G.start);
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? +wG(B) : +wG(U);
    let J = Z ? wG(U) : wG(B);
    let Q =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!Q) return [];
    if (Q < 0) (Q = -Q), (Z = !Z);
    const H = [];
    while (+J <= j) H.push(q(J)), (J = HK(J, Q));
    return Z ? H.reverse() : H;
  }
  function I0(G, X) {
    let K;
    const B = q(G.start);
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? f(U, X) : f(B, X);
    const J = Z ? f(B, X) : f(U, X);
    j.setHours(15), J.setHours(15);
    const Q = +J.getTime();
    let H = j;
    let x =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!x) return [];
    if (x < 0) (x = -x), (Z = !Z);
    const A = [];
    while (+H <= Q) H.setHours(0), A.push(q(H)), (H = mG(H, x)), H.setHours(15);
    return Z ? A.reverse() : A;
  }
  function EK(G) {
    const X = KX(G);
    const K = [];
    let B = 0;
    while (B < X.length) {
      const U = X[B++];
      if (QG(U)) K.push(U);
    }
    return K;
  }
  function iG(G) {
    const X = q(G);
    return X.setDate(1), X.setHours(0, 0, 0, 0), X;
  }
  function b0(G) {
    const X = iG(G);
    const K = VK(G);
    return EK({ start: X, end: K });
  }
  function XX(G) {
    const X = q(G);
    const K = X.getFullYear();
    return X.setFullYear(K + 1, 0, 0), X.setHours(23, 59, 59, 999), X;
  }
  function FK(G) {
    const X = q(G);
    const K = M(G, 0);
    return K.setFullYear(X.getFullYear(), 0, 1), K.setHours(0, 0, 0, 0), K;
  }
  function M0(G) {
    const X = FK(G);
    const K = XX(G);
    return EK({ start: X, end: K });
  }
  function Y0(G, X) {
    let K;
    const B = q(G.start);
    const U = q(G.end);
    let Z = +B > +U;
    const j = Z ? +B : +U;
    const J = Z ? U : B;
    J.setHours(0, 0, 0, 0), J.setMonth(0, 1);
    let Q =
      (K = X === null || X === void 0 ? void 0 : X.step) !== null &&
      K !== void 0
        ? K
        : 1;
    if (!Q) return [];
    if (Q < 0) (Q = -Q), (Z = !Z);
    const H = [];
    while (+J <= j) H.push(q(J)), J.setFullYear(J.getFullYear() + Q);
    return Z ? H.reverse() : H;
  }
  function T0(G) {
    const X = q(G);
    const K = X.getFullYear();
    const B = 9 + Math.floor(K / 10) * 10;
    return X.setFullYear(B, 11, 31), X.setHours(23, 59, 59, 999), X;
  }
  function z0(G) {
    const X = q(G);
    return X.setMinutes(59, 59, 999), X;
  }
  function BX(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    let J;
    const Q = _();
    const H =
      (K =
        (B =
          (U =
            (Z = X === null || X === void 0 ? void 0 : X.weekStartsOn) !==
              null && Z !== void 0
              ? Z
              : X === null ||
                  X === void 0 ||
                  (j = X.locale) === null ||
                  j === void 0 ||
                  (j = j.options) === null ||
                  j === void 0
                ? void 0
                : j.weekStartsOn) !== null && U !== void 0
            ? U
            : Q.weekStartsOn) !== null && B !== void 0
          ? B
          : (J = Q.locale) === null ||
              J === void 0 ||
              (J = J.options) === null ||
              J === void 0
            ? void 0
            : J.weekStartsOn) !== null && K !== void 0
        ? K
        : 0;
    const x = q(G);
    const A = x.getDay();
    const E = (A < H ? -7 : 0) + 6 - (A - H);
    return x.setDate(x.getDate() + E), x.setHours(23, 59, 59, 999), x;
  }
  function W0(G) {
    return BX(G, { weekStartsOn: 1 });
  }
  function R0(G) {
    const X = HG(G);
    const K = M(G, 0);
    K.setFullYear(X + 1, 0, 4), K.setHours(0, 0, 0, 0);
    const B = GG(K);
    return B.setMilliseconds(B.getMilliseconds() - 1), B;
  }
  function L0(G) {
    const X = q(G);
    return X.setSeconds(59, 999), X;
  }
  function $0(G) {
    const X = q(G);
    const K = X.getMonth();
    const B = K - (K % 3) + 3;
    return X.setMonth(B, 0), X.setHours(23, 59, 59, 999), X;
  }
  function P0(G) {
    const X = q(G);
    return X.setMilliseconds(999), X;
  }
  function D0() {
    return NK(Date.now());
  }
  function v0() {
    const G = new Date();
    const X = G.getFullYear();
    const K = G.getMonth();
    const B = G.getDate();
    const U = new Date(0);
    return U.setFullYear(X, K, B + 1), U.setHours(23, 59, 59, 999), U;
  }
  function O0() {
    const G = new Date();
    const X = G.getFullYear();
    const K = G.getMonth();
    const B = G.getDate();
    const U = new Date(0);
    return U.setFullYear(X, K, B - 1), U.setHours(23, 59, 59, 999), U;
  }
  const S0 = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds",
    },
    xSeconds: { one: "1 second", other: "{{count}} seconds" },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes",
    },
    xMinutes: { one: "1 minute", other: "{{count}} minutes" },
    aboutXHours: { one: "about 1 hour", other: "about {{count}} hours" },
    xHours: { one: "1 hour", other: "{{count}} hours" },
    xDays: { one: "1 day", other: "{{count}} days" },
    aboutXWeeks: { one: "about 1 week", other: "about {{count}} weeks" },
    xWeeks: { one: "1 week", other: "{{count}} weeks" },
    aboutXMonths: { one: "about 1 month", other: "about {{count}} months" },
    xMonths: { one: "1 month", other: "{{count}} months" },
    aboutXYears: { one: "about 1 year", other: "about {{count}} years" },
    xYears: { one: "1 year", other: "{{count}} years" },
    overXYears: { one: "over 1 year", other: "over {{count}} years" },
    almostXYears: { one: "almost 1 year", other: "almost {{count}} years" },
  };
  const y0 = function G(X, K, B) {
    let U;
    const Z = S0[X];
    if (typeof Z === "string") U = Z;
    else if (K === 1) U = Z.one;
    else U = Z.other.replace("{{count}}", K.toString());
    if (B !== null && B !== void 0 && B.addSuffix)
      if (B.comparison && B.comparison > 0) return `in ${U}`;
      else return `${U} ago`;
    return U;
  };
  function CK(G) {
    return function () {
      const X =
        arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const K = X.width ? String(X.width) : G.defaultWidth;
      const B = G.formats[K] || G.formats[G.defaultWidth];
      return B;
    };
  }
  const k0 = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy",
  };
  const h0 = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a",
  };
  const m0 = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}",
  };
  const g0 = {
    date: CK({ formats: k0, defaultWidth: "full" }),
    time: CK({ formats: h0, defaultWidth: "full" }),
    dateTime: CK({ formats: m0, defaultWidth: "full" }),
  };
  const c0 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P",
  };
  const f0 = function G(X, K, B, U) {
    return c0[X];
  };
  function DG(G) {
    return function (X, K) {
      const B =
        K !== null && K !== void 0 && K.context
          ? String(K.context)
          : "standalone";
      let U;
      if (B === "formatting" && G.formattingValues) {
        const Z = G.defaultFormattingWidth || G.defaultWidth;
        const j = K !== null && K !== void 0 && K.width ? String(K.width) : Z;
        U = G.formattingValues[j] || G.formattingValues[Z];
      } else {
        const J = G.defaultWidth;
        const Q =
          K !== null && K !== void 0 && K.width
            ? String(K.width)
            : G.defaultWidth;
        U = G.values[Q] || G.values[J];
      }
      const H = G.argumentCallback ? G.argumentCallback(X) : X;
      return U[H];
    };
  }
  const p0 = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"],
  };
  const u0 = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
  };
  const _0 = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    wide: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  };
  const l0 = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
  };
  const d0 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night",
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night",
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night",
    },
  };
  const i0 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night",
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night",
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night",
    },
  };
  const s0 = function G(X, K) {
    const B = Number(X);
    const U = B % 100;
    if (U > 20 || U < 10)
      switch (U % 10) {
        case 1:
          return `${B}st`;
        case 2:
          return `${B}nd`;
        case 3:
          return `${B}rd`;
      }
    return `${B}th`;
  };
  const n0 = {
    ordinalNumber: s0,
    era: DG({ values: p0, defaultWidth: "wide" }),
    quarter: DG({
      values: u0,
      defaultWidth: "wide",
      argumentCallback: function G(X) {
        return X - 1;
      },
    }),
    month: DG({ values: _0, defaultWidth: "wide" }),
    day: DG({ values: l0, defaultWidth: "wide" }),
    dayPeriod: DG({
      values: d0,
      defaultWidth: "wide",
      formattingValues: i0,
      defaultFormattingWidth: "wide",
    }),
  };
  function vG(G) {
    return function (X) {
      const K =
        arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const B = K.width;
      const U =
        (B && G.matchPatterns[B]) || G.matchPatterns[G.defaultMatchWidth];
      const Z = X.match(U);
      if (!Z) return null;
      const j = Z[0];
      const J =
        (B && G.parsePatterns[B]) || G.parsePatterns[G.defaultParseWidth];
      const Q = Array.isArray(J)
        ? o0(J, (A) => {
            return A.test(j);
          })
        : r0(J, (A) => {
            return A.test(j);
          });
      let H;
      (H = G.valueCallback ? G.valueCallback(Q) : Q),
        (H = K.valueCallback ? K.valueCallback(H) : H);
      const x = X.slice(j.length);
      return { value: H, rest: x };
    };
  }
  var r0 = function G(X, K) {
    for (const B in X)
      if (Object.prototype.hasOwnProperty.call(X, B) && K(X[B])) return B;
  };
  var o0 = function G(X, K) {
    for (let B = 0; B < X.length; B++) if (K(X[B])) return B;
  };
  function a0(G) {
    return function (X) {
      const K =
        arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const B = X.match(G.matchPattern);
      if (!B) return null;
      const U = B[0];
      const Z = X.match(G.parsePattern);
      if (!Z) return null;
      let j = G.valueCallback ? G.valueCallback(Z[0]) : Z[0];
      j = K.valueCallback ? K.valueCallback(j) : j;
      const J = X.slice(U.length);
      return { value: j, rest: J };
    };
  }
  const e0 = /^(\d+)(th|st|nd|rd)?/i;
  const t0 = /\d+/i;
  const GB = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i,
  };
  const KB = { any: [/^b/i, /^(a|c)/i] };
  const XB = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i,
  };
  const BB = { any: [/1/i, /2/i, /3/i, /4/i] };
  const UB = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
  };
  const ZB = {
    narrow: [
      /^j/i,
      /^f/i,
      /^m/i,
      /^a/i,
      /^m/i,
      /^j/i,
      /^j/i,
      /^a/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i,
    ],
    any: [
      /^ja/i,
      /^f/i,
      /^mar/i,
      /^ap/i,
      /^may/i,
      /^jun/i,
      /^jul/i,
      /^au/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i,
    ],
  };
  const jB = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
  };
  const JB = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
  };
  const qB = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
  };
  const QB = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i,
    },
  };
  const HB = {
    ordinalNumber: a0({
      matchPattern: e0,
      parsePattern: t0,
      valueCallback: function G(X) {
        return parseInt(X, 10);
      },
    }),
    era: vG({
      matchPatterns: GB,
      defaultMatchWidth: "wide",
      parsePatterns: KB,
      defaultParseWidth: "any",
    }),
    quarter: vG({
      matchPatterns: XB,
      defaultMatchWidth: "wide",
      parsePatterns: BB,
      defaultParseWidth: "any",
      valueCallback: function G(X) {
        return X + 1;
      },
    }),
    month: vG({
      matchPatterns: UB,
      defaultMatchWidth: "wide",
      parsePatterns: ZB,
      defaultParseWidth: "any",
    }),
    day: vG({
      matchPatterns: jB,
      defaultMatchWidth: "wide",
      parsePatterns: JB,
      defaultParseWidth: "any",
    }),
    dayPeriod: vG({
      matchPatterns: qB,
      defaultMatchWidth: "any",
      parsePatterns: QB,
      defaultParseWidth: "any",
    }),
  };
  const TG = {
    code: "en-US",
    formatDistance: y0,
    formatLong: g0,
    formatRelative: f0,
    localize: n0,
    match: HB,
    options: { weekStartsOn: 0, firstWeekContainsDate: 1 },
  };
  function UX(G) {
    const X = q(G);
    const K = KG(X, FK(X));
    const B = K + 1;
    return B;
  }
  function wK(G) {
    const X = q(G);
    const K = +GG(X) - +xG(X);
    return Math.round(K / LG) + 1;
  }
  function sG(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    let J;
    const Q = q(G);
    const H = Q.getFullYear();
    const x = _();
    const A =
      (K =
        (B =
          (U =
            (Z =
              X === null || X === void 0 ? void 0 : X.firstWeekContainsDate) !==
              null && Z !== void 0
              ? Z
              : X === null ||
                  X === void 0 ||
                  (j = X.locale) === null ||
                  j === void 0 ||
                  (j = j.options) === null ||
                  j === void 0
                ? void 0
                : j.firstWeekContainsDate) !== null && U !== void 0
            ? U
            : x.firstWeekContainsDate) !== null && B !== void 0
          ? B
          : (J = x.locale) === null ||
              J === void 0 ||
              (J = J.options) === null ||
              J === void 0
            ? void 0
            : J.firstWeekContainsDate) !== null && K !== void 0
        ? K
        : 1;
    const E = M(G, 0);
    E.setFullYear(H + 1, 0, A), E.setHours(0, 0, 0, 0);
    const T = f(E, X);
    const I = M(G, 0);
    I.setFullYear(H, 0, A), I.setHours(0, 0, 0, 0);
    const z = f(I, X);
    if (Q.getTime() >= T.getTime()) return H + 1;
    else if (Q.getTime() >= z.getTime()) return H;
    else return H - 1;
  }
  function nG(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    let J;
    const Q = _();
    const H =
      (K =
        (B =
          (U =
            (Z =
              X === null || X === void 0 ? void 0 : X.firstWeekContainsDate) !==
              null && Z !== void 0
              ? Z
              : X === null ||
                  X === void 0 ||
                  (j = X.locale) === null ||
                  j === void 0 ||
                  (j = j.options) === null ||
                  j === void 0
                ? void 0
                : j.firstWeekContainsDate) !== null && U !== void 0
            ? U
            : Q.firstWeekContainsDate) !== null && B !== void 0
          ? B
          : (J = Q.locale) === null ||
              J === void 0 ||
              (J = J.options) === null ||
              J === void 0
            ? void 0
            : J.firstWeekContainsDate) !== null && K !== void 0
        ? K
        : 1;
    const x = sG(G, X);
    const A = M(G, 0);
    A.setFullYear(x, 0, H), A.setHours(0, 0, 0, 0);
    const E = f(A, X);
    return E;
  }
  function IK(G, X) {
    const K = q(G);
    const B = +f(K, X) - +nG(K, X);
    return Math.round(B / LG) + 1;
  }
  function b(G, X) {
    const K = G < 0 ? "-" : "";
    const B = Math.abs(G).toString().padStart(X, "0");
    return K + B;
  }
  var BG = {
    y: function G(X, K) {
      const B = X.getFullYear();
      const U = B > 0 ? B : 1 - B;
      return b(K === "yy" ? U % 100 : U, K.length);
    },
    M: function G(X, K) {
      const B = X.getMonth();
      return K === "M" ? String(B + 1) : b(B + 1, 2);
    },
    d: function G(X, K) {
      return b(X.getDate(), K.length);
    },
    a: function G(X, K) {
      const B = X.getHours() / 12 >= 1 ? "pm" : "am";
      switch (K) {
        case "a":
        case "aa":
          return B.toUpperCase();
        case "aaa":
          return B;
        case "aaaaa":
          return B[0];
        case "aaaa":
        default:
          return B === "am" ? "a.m." : "p.m.";
      }
    },
    h: function G(X, K) {
      return b(X.getHours() % 12 || 12, K.length);
    },
    H: function G(X, K) {
      return b(X.getHours(), K.length);
    },
    m: function G(X, K) {
      return b(X.getMinutes(), K.length);
    },
    s: function G(X, K) {
      return b(X.getSeconds(), K.length);
    },
    S: function G(X, K) {
      const B = K.length;
      const U = X.getMilliseconds();
      const Z = Math.trunc(U * Math.pow(10, B - 3));
      return b(Z, K.length);
    },
  };
  const ZX = function G(X) {
    const K =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const B = X > 0 ? "-" : "+";
    const U = Math.abs(X);
    const Z = Math.trunc(U / 60);
    const j = U % 60;
    if (j === 0) return B + String(Z);
    return B + String(Z) + K + b(j, 2);
  };
  const jX = function G(X, K) {
    if (X % 60 === 0) {
      const B = X > 0 ? "-" : "+";
      return B + b(Math.abs(X) / 60, 2);
    }
    return IG(X, K);
  };
  var IG = function G(X) {
    const K =
      arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const B = X > 0 ? "-" : "+";
    const U = Math.abs(X);
    const Z = b(Math.trunc(U / 60), 2);
    const j = b(U % 60, 2);
    return B + Z + K + j;
  };
  const zG = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  };
  var bK = {
    G: function G(X, K, B) {
      const U = X.getFullYear() > 0 ? 1 : 0;
      switch (K) {
        case "G":
        case "GG":
        case "GGG":
          return B.era(U, { width: "abbreviated" });
        case "GGGGG":
          return B.era(U, { width: "narrow" });
        case "GGGG":
        default:
          return B.era(U, { width: "wide" });
      }
    },
    y: function G(X, K, B) {
      if (K === "yo") {
        const U = X.getFullYear();
        const Z = U > 0 ? U : 1 - U;
        return B.ordinalNumber(Z, { unit: "year" });
      }
      return BG.y(X, K);
    },
    Y: function G(X, K, B, U) {
      const Z = sG(X, U);
      const j = Z > 0 ? Z : 1 - Z;
      if (K === "YY") {
        const J = j % 100;
        return b(J, 2);
      }
      if (K === "Yo") return B.ordinalNumber(j, { unit: "year" });
      return b(j, K.length);
    },
    R: function G(X, K) {
      const B = HG(X);
      return b(B, K.length);
    },
    u: function G(X, K) {
      const B = X.getFullYear();
      return b(B, K.length);
    },
    Q: function G(X, K, B) {
      const U = Math.ceil((X.getMonth() + 1) / 3);
      switch (K) {
        case "Q":
          return String(U);
        case "QQ":
          return b(U, 2);
        case "Qo":
          return B.ordinalNumber(U, { unit: "quarter" });
        case "QQQ":
          return B.quarter(U, { width: "abbreviated", context: "formatting" });
        case "QQQQQ":
          return B.quarter(U, { width: "narrow", context: "formatting" });
        case "QQQQ":
        default:
          return B.quarter(U, { width: "wide", context: "formatting" });
      }
    },
    q: function G(X, K, B) {
      const U = Math.ceil((X.getMonth() + 1) / 3);
      switch (K) {
        case "q":
          return String(U);
        case "qq":
          return b(U, 2);
        case "qo":
          return B.ordinalNumber(U, { unit: "quarter" });
        case "qqq":
          return B.quarter(U, { width: "abbreviated", context: "standalone" });
        case "qqqqq":
          return B.quarter(U, { width: "narrow", context: "standalone" });
        case "qqqq":
        default:
          return B.quarter(U, { width: "wide", context: "standalone" });
      }
    },
    M: function G(X, K, B) {
      const U = X.getMonth();
      switch (K) {
        case "M":
        case "MM":
          return BG.M(X, K);
        case "Mo":
          return B.ordinalNumber(U + 1, { unit: "month" });
        case "MMM":
          return B.month(U, { width: "abbreviated", context: "formatting" });
        case "MMMMM":
          return B.month(U, { width: "narrow", context: "formatting" });
        case "MMMM":
        default:
          return B.month(U, { width: "wide", context: "formatting" });
      }
    },
    L: function G(X, K, B) {
      const U = X.getMonth();
      switch (K) {
        case "L":
          return String(U + 1);
        case "LL":
          return b(U + 1, 2);
        case "Lo":
          return B.ordinalNumber(U + 1, { unit: "month" });
        case "LLL":
          return B.month(U, { width: "abbreviated", context: "standalone" });
        case "LLLLL":
          return B.month(U, { width: "narrow", context: "standalone" });
        case "LLLL":
        default:
          return B.month(U, { width: "wide", context: "standalone" });
      }
    },
    w: function G(X, K, B, U) {
      const Z = IK(X, U);
      if (K === "wo") return B.ordinalNumber(Z, { unit: "week" });
      return b(Z, K.length);
    },
    I: function G(X, K, B) {
      const U = wK(X);
      if (K === "Io") return B.ordinalNumber(U, { unit: "week" });
      return b(U, K.length);
    },
    d: function G(X, K, B) {
      if (K === "do") return B.ordinalNumber(X.getDate(), { unit: "date" });
      return BG.d(X, K);
    },
    D: function G(X, K, B) {
      const U = UX(X);
      if (K === "Do") return B.ordinalNumber(U, { unit: "dayOfYear" });
      return b(U, K.length);
    },
    E: function G(X, K, B) {
      const U = X.getDay();
      switch (K) {
        case "E":
        case "EE":
        case "EEE":
          return B.day(U, { width: "abbreviated", context: "formatting" });
        case "EEEEE":
          return B.day(U, { width: "narrow", context: "formatting" });
        case "EEEEEE":
          return B.day(U, { width: "short", context: "formatting" });
        case "EEEE":
        default:
          return B.day(U, { width: "wide", context: "formatting" });
      }
    },
    e: function G(X, K, B, U) {
      const Z = X.getDay();
      const j = (Z - U.weekStartsOn + 8) % 7 || 7;
      switch (K) {
        case "e":
          return String(j);
        case "ee":
          return b(j, 2);
        case "eo":
          return B.ordinalNumber(j, { unit: "day" });
        case "eee":
          return B.day(Z, { width: "abbreviated", context: "formatting" });
        case "eeeee":
          return B.day(Z, { width: "narrow", context: "formatting" });
        case "eeeeee":
          return B.day(Z, { width: "short", context: "formatting" });
        case "eeee":
        default:
          return B.day(Z, { width: "wide", context: "formatting" });
      }
    },
    c: function G(X, K, B, U) {
      const Z = X.getDay();
      const j = (Z - U.weekStartsOn + 8) % 7 || 7;
      switch (K) {
        case "c":
          return String(j);
        case "cc":
          return b(j, K.length);
        case "co":
          return B.ordinalNumber(j, { unit: "day" });
        case "ccc":
          return B.day(Z, { width: "abbreviated", context: "standalone" });
        case "ccccc":
          return B.day(Z, { width: "narrow", context: "standalone" });
        case "cccccc":
          return B.day(Z, { width: "short", context: "standalone" });
        case "cccc":
        default:
          return B.day(Z, { width: "wide", context: "standalone" });
      }
    },
    i: function G(X, K, B) {
      const U = X.getDay();
      const Z = U === 0 ? 7 : U;
      switch (K) {
        case "i":
          return String(Z);
        case "ii":
          return b(Z, K.length);
        case "io":
          return B.ordinalNumber(Z, { unit: "day" });
        case "iii":
          return B.day(U, { width: "abbreviated", context: "formatting" });
        case "iiiii":
          return B.day(U, { width: "narrow", context: "formatting" });
        case "iiiiii":
          return B.day(U, { width: "short", context: "formatting" });
        case "iiii":
        default:
          return B.day(U, { width: "wide", context: "formatting" });
      }
    },
    a: function G(X, K, B) {
      const U = X.getHours();
      const Z = U / 12 >= 1 ? "pm" : "am";
      switch (K) {
        case "a":
        case "aa":
          return B.dayPeriod(Z, {
            width: "abbreviated",
            context: "formatting",
          });
        case "aaa":
          return B.dayPeriod(Z, {
            width: "abbreviated",
            context: "formatting",
          }).toLowerCase();
        case "aaaaa":
          return B.dayPeriod(Z, { width: "narrow", context: "formatting" });
        case "aaaa":
        default:
          return B.dayPeriod(Z, { width: "wide", context: "formatting" });
      }
    },
    b: function G(X, K, B) {
      const U = X.getHours();
      let Z;
      if (U === 12) Z = zG.noon;
      else if (U === 0) Z = zG.midnight;
      else Z = U / 12 >= 1 ? "pm" : "am";
      switch (K) {
        case "b":
        case "bb":
          return B.dayPeriod(Z, {
            width: "abbreviated",
            context: "formatting",
          });
        case "bbb":
          return B.dayPeriod(Z, {
            width: "abbreviated",
            context: "formatting",
          }).toLowerCase();
        case "bbbbb":
          return B.dayPeriod(Z, { width: "narrow", context: "formatting" });
        case "bbbb":
        default:
          return B.dayPeriod(Z, { width: "wide", context: "formatting" });
      }
    },
    B: function G(X, K, B) {
      const U = X.getHours();
      let Z;
      if (U >= 17) Z = zG.evening;
      else if (U >= 12) Z = zG.afternoon;
      else if (U >= 4) Z = zG.morning;
      else Z = zG.night;
      switch (K) {
        case "B":
        case "BB":
        case "BBB":
          return B.dayPeriod(Z, {
            width: "abbreviated",
            context: "formatting",
          });
        case "BBBBB":
          return B.dayPeriod(Z, { width: "narrow", context: "formatting" });
        case "BBBB":
        default:
          return B.dayPeriod(Z, { width: "wide", context: "formatting" });
      }
    },
    h: function G(X, K, B) {
      if (K === "ho") {
        let U = X.getHours() % 12;
        if (U === 0) U = 12;
        return B.ordinalNumber(U, { unit: "hour" });
      }
      return BG.h(X, K);
    },
    H: function G(X, K, B) {
      if (K === "Ho") return B.ordinalNumber(X.getHours(), { unit: "hour" });
      return BG.H(X, K);
    },
    K: function G(X, K, B) {
      const U = X.getHours() % 12;
      if (K === "Ko") return B.ordinalNumber(U, { unit: "hour" });
      return b(U, K.length);
    },
    k: function G(X, K, B) {
      let U = X.getHours();
      if (U === 0) U = 24;
      if (K === "ko") return B.ordinalNumber(U, { unit: "hour" });
      return b(U, K.length);
    },
    m: function G(X, K, B) {
      if (K === "mo")
        return B.ordinalNumber(X.getMinutes(), { unit: "minute" });
      return BG.m(X, K);
    },
    s: function G(X, K, B) {
      if (K === "so")
        return B.ordinalNumber(X.getSeconds(), { unit: "second" });
      return BG.s(X, K);
    },
    S: function G(X, K) {
      return BG.S(X, K);
    },
    X: function G(X, K, B) {
      const U = X.getTimezoneOffset();
      if (U === 0) return "Z";
      switch (K) {
        case "X":
          return jX(U);
        case "XXXX":
        case "XX":
          return IG(U);
        case "XXXXX":
        case "XXX":
        default:
          return IG(U, ":");
      }
    },
    x: function G(X, K, B) {
      const U = X.getTimezoneOffset();
      switch (K) {
        case "x":
          return jX(U);
        case "xxxx":
        case "xx":
          return IG(U);
        case "xxxxx":
        case "xxx":
        default:
          return IG(U, ":");
      }
    },
    O: function G(X, K, B) {
      const U = X.getTimezoneOffset();
      switch (K) {
        case "O":
        case "OO":
        case "OOO":
          return `GMT${ZX(U, ":")}`;
        case "OOOO":
        default:
          return `GMT${IG(U, ":")}`;
      }
    },
    z: function G(X, K, B) {
      const U = X.getTimezoneOffset();
      switch (K) {
        case "z":
        case "zz":
        case "zzz":
          return `GMT${ZX(U, ":")}`;
        case "zzzz":
        default:
          return `GMT${IG(U, ":")}`;
      }
    },
    t: function G(X, K, B) {
      const U = Math.trunc(X.getTime() / 1000);
      return b(U, K.length);
    },
    T: function G(X, K, B) {
      const U = X.getTime();
      return b(U, K.length);
    },
  };
  const JX = function G(X, K) {
    switch (X) {
      case "P":
        return K.date({ width: "short" });
      case "PP":
        return K.date({ width: "medium" });
      case "PPP":
        return K.date({ width: "long" });
      case "PPPP":
      default:
        return K.date({ width: "full" });
    }
  };
  const qX = function G(X, K) {
    switch (X) {
      case "p":
        return K.time({ width: "short" });
      case "pp":
        return K.time({ width: "medium" });
      case "ppp":
        return K.time({ width: "long" });
      case "pppp":
      default:
        return K.time({ width: "full" });
    }
  };
  const xB = function G(X, K) {
    const B = X.match(/(P+)(p+)?/) || [];
    const U = B[1];
    const Z = B[2];
    if (!Z) return JX(X, K);
    let j;
    switch (U) {
      case "P":
        j = K.dateTime({ width: "short" });
        break;
      case "PP":
        j = K.dateTime({ width: "medium" });
        break;
      case "PPP":
        j = K.dateTime({ width: "long" });
        break;
      case "PPPP":
      default:
        j = K.dateTime({ width: "full" });
        break;
    }
    return j.replace("{{date}}", JX(U, K)).replace("{{time}}", qX(Z, K));
  };
  var rG = { p: qX, P: xB };
  function QX(G) {
    return NB.test(G);
  }
  function HX(G) {
    return VB.test(G);
  }
  function MK(G, X, K) {
    const B = AB(G, X, K);
    if ((console.warn(B), EB.includes(G))) throw new RangeError(B);
  }
  var AB = function G(X, K, B) {
    const U = X[0] === "Y" ? "years" : "days of the month";
    return "Use `"
      .concat(X.toLowerCase(), "` instead of `")
      .concat(X, "` (in `")
      .concat(K, "`) for formatting ")
      .concat(U, " to the input `")
      .concat(
        B,
        "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md",
      );
  };
  var NB = /^D+$/;
  var VB = /^Y+$/;
  var EB = ["D", "DD", "YY", "YYYY"];
  function YK(G, X, K) {
    let B;
    let U;
    let Z;
    let j;
    let J;
    let Q;
    let H;
    let x;
    let A;
    let E;
    let T;
    let I;
    let z;
    let Y;
    const W = _();
    const R =
      (B =
        (U = K === null || K === void 0 ? void 0 : K.locale) !== null &&
        U !== void 0
          ? U
          : W.locale) !== null && B !== void 0
        ? B
        : TG;
    const m =
      (Z =
        (j =
          (J =
            (Q =
              K === null || K === void 0 ? void 0 : K.firstWeekContainsDate) !==
              null && Q !== void 0
              ? Q
              : K === null ||
                  K === void 0 ||
                  (H = K.locale) === null ||
                  H === void 0 ||
                  (H = H.options) === null ||
                  H === void 0
                ? void 0
                : H.firstWeekContainsDate) !== null && J !== void 0
            ? J
            : W.firstWeekContainsDate) !== null && j !== void 0
          ? j
          : (x = W.locale) === null ||
              x === void 0 ||
              (x = x.options) === null ||
              x === void 0
            ? void 0
            : x.firstWeekContainsDate) !== null && Z !== void 0
        ? Z
        : 1;
    const l =
      (A =
        (E =
          (T =
            (I = K === null || K === void 0 ? void 0 : K.weekStartsOn) !==
              null && I !== void 0
              ? I
              : K === null ||
                  K === void 0 ||
                  (z = K.locale) === null ||
                  z === void 0 ||
                  (z = z.options) === null ||
                  z === void 0
                ? void 0
                : z.weekStartsOn) !== null && T !== void 0
            ? T
            : W.weekStartsOn) !== null && E !== void 0
          ? E
          : (Y = W.locale) === null ||
              Y === void 0 ||
              (Y = Y.options) === null ||
              Y === void 0
            ? void 0
            : Y.weekStartsOn) !== null && A !== void 0
        ? A
        : 0;
    const r = q(G);
    if (!qG(r)) throw new RangeError("Invalid time value");
    let o = X.match(wB)
      .map((p) => {
        const g = p[0];
        if (g === "p" || g === "P") {
          const EG = rG[g];
          return EG(p, R.formatLong);
        }
        return p;
      })
      .join("")
      .match(CB)
      .map((p) => {
        if (p === "''") return { isToken: !1, value: "'" };
        const g = p[0];
        if (g === "'") return { isToken: !1, value: FB(p) };
        if (bK[g]) return { isToken: !0, value: p };
        if (g.match(MB))
          throw new RangeError(
            `Format string contains an unescaped latin alphabet character \`${g}\``,
          );
        return { isToken: !1, value: p };
      });
    if (R.localize.preprocessor) o = R.localize.preprocessor(r, o);
    const jG = { firstWeekContainsDate: m, weekStartsOn: l, locale: R };
    return o
      .map((p) => {
        if (!p.isToken) return p.value;
        const g = p.value;
        if (
          (!(K !== null && K !== void 0 && K.useAdditionalWeekYearTokens) &&
            HX(g)) ||
          (!(K !== null && K !== void 0 && K.useAdditionalDayOfYearTokens) &&
            QX(g))
        )
          MK(g, X, String(G));
        const EG = bK[g[0]];
        return EG(r, g, R.localize, jG);
      })
      .join("");
  }
  var FB = function G(X) {
    const K = X.match(IB);
    if (!K) return X;
    return K[1].replace(bB, "'");
  };
  var CB = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
  var wB = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var IB = /^'([^]*?)'?$/;
  var bB = /''/g;
  var MB = /[a-zA-Z]/;
  function xX(G, X, K) {
    let B;
    let U;
    const Z = _();
    const j =
      (B =
        (U = K === null || K === void 0 ? void 0 : K.locale) !== null &&
        U !== void 0
          ? U
          : Z.locale) !== null && B !== void 0
        ? B
        : TG;
    const J = 2520;
    const Q = XG(G, X);
    if (isNaN(Q)) throw new RangeError("Invalid time value");
    const H = Object.assign({}, K, {
      addSuffix: K === null || K === void 0 ? void 0 : K.addSuffix,
      comparison: Q,
    });
    let x;
    let A;
    if (Q > 0) (x = q(X)), (A = q(G));
    else (x = q(G)), (A = q(X));
    const E = YG(A, x);
    const T = (i(A) - i(x)) / 1000;
    const I = Math.round((E - T) / 60);
    let z;
    if (I < 2)
      if (K !== null && K !== void 0 && K.includeSeconds)
        if (E < 5) return j.formatDistance("lessThanXSeconds", 5, H);
        else if (E < 10) return j.formatDistance("lessThanXSeconds", 10, H);
        else if (E < 20) return j.formatDistance("lessThanXSeconds", 20, H);
        else if (E < 40) return j.formatDistance("halfAMinute", 0, H);
        else if (E < 60) return j.formatDistance("lessThanXMinutes", 1, H);
        else return j.formatDistance("xMinutes", 1, H);
      else if (I === 0) return j.formatDistance("lessThanXMinutes", 1, H);
      else return j.formatDistance("xMinutes", I, H);
    else if (I < 45) return j.formatDistance("xMinutes", I, H);
    else if (I < 90) return j.formatDistance("aboutXHours", 1, H);
    else if (I < kG) {
      const Y = Math.round(I / 60);
      return j.formatDistance("aboutXHours", Y, H);
    } else if (I < J) return j.formatDistance("xDays", 1, H);
    else if (I < bG) {
      const W = Math.round(I / kG);
      return j.formatDistance("xDays", W, H);
    } else if (I < bG * 2)
      return (z = Math.round(I / bG)), j.formatDistance("aboutXMonths", z, H);
    if (((z = lG(A, x)), z < 12)) {
      const R = Math.round(I / bG);
      return j.formatDistance("xMonths", R, H);
    } else {
      const m = z % 12;
      const l = Math.trunc(z / 12);
      if (m < 3) return j.formatDistance("aboutXYears", l, H);
      else if (m < 9) return j.formatDistance("overXYears", l, H);
      else return j.formatDistance("almostXYears", l + 1, H);
    }
  }
  function AX(G, X, K) {
    let B;
    let U;
    let Z;
    const j = _();
    const J =
      (B =
        (U = K === null || K === void 0 ? void 0 : K.locale) !== null &&
        U !== void 0
          ? U
          : j.locale) !== null && B !== void 0
        ? B
        : TG;
    const Q = XG(G, X);
    if (isNaN(Q)) throw new RangeError("Invalid time value");
    const H = Object.assign({}, K, {
      addSuffix: K === null || K === void 0 ? void 0 : K.addSuffix,
      comparison: Q,
    });
    let x;
    let A;
    if (Q > 0) (x = q(X)), (A = q(G));
    else (x = q(G)), (A = q(X));
    const E = AG(
      (Z = K === null || K === void 0 ? void 0 : K.roundingMethod) !== null &&
        Z !== void 0
        ? Z
        : "round",
    );
    const T = A.getTime() - x.getTime();
    const I = T / JG;
    const z = i(A) - i(x);
    const Y = (T - z) / JG;
    const W = K === null || K === void 0 ? void 0 : K.unit;
    let R;
    if (!W)
      if (I < 1) R = "second";
      else if (I < 60) R = "minute";
      else if (I < kG) R = "hour";
      else if (Y < bG) R = "day";
      else if (Y < kK) R = "month";
      else R = "year";
    else R = W;
    if (R === "second") {
      const m = E(T / 1000);
      return J.formatDistance("xSeconds", m, H);
    } else if (R === "minute") {
      const l = E(I);
      return J.formatDistance("xMinutes", l, H);
    } else if (R === "hour") {
      const r = E(I / 60);
      return J.formatDistance("xHours", r, H);
    } else if (R === "day") {
      const o = E(Y / kG);
      return J.formatDistance("xDays", o, H);
    } else if (R === "month") {
      const jG = E(Y / bG);
      return jG === 12 && W !== "month"
        ? J.formatDistance("xYears", 1, H)
        : J.formatDistance("xMonths", jG, H);
    } else {
      const p = E(Y / kK);
      return J.formatDistance("xYears", p, H);
    }
  }
  function YB(G, X) {
    return xX(G, s(G), X);
  }
  function TB(G, X) {
    return AX(G, s(G), X);
  }
  function zB(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    const J = _();
    const Q =
      (K =
        (B = X === null || X === void 0 ? void 0 : X.locale) !== null &&
        B !== void 0
          ? B
          : J.locale) !== null && K !== void 0
        ? K
        : TG;
    const H =
      (U = X === null || X === void 0 ? void 0 : X.format) !== null &&
      U !== void 0
        ? U
        : WB;
    const x =
      (Z = X === null || X === void 0 ? void 0 : X.zero) !== null &&
      Z !== void 0
        ? Z
        : !1;
    const A =
      (j = X === null || X === void 0 ? void 0 : X.delimiter) !== null &&
      j !== void 0
        ? j
        : " ";
    if (!Q.formatDistance) return "";
    const E = H.reduce((T, I) => {
      const z = "x".concat(
        I.replace(/(^.)/, (W) => {
          return W.toUpperCase();
        }),
      );
      const Y = G[I];
      if (Y !== void 0 && (x || G[I])) return T.concat(Q.formatDistance(z, Y));
      return T;
    }, []).join(A);
    return E;
  }
  var WB = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
  function RB(G, X) {
    let K;
    let B;
    const U = q(G);
    if (isNaN(U.getTime())) throw new RangeError("Invalid time value");
    const Z =
      (K = X === null || X === void 0 ? void 0 : X.format) !== null &&
      K !== void 0
        ? K
        : "extended";
    const j =
      (B = X === null || X === void 0 ? void 0 : X.representation) !== null &&
      B !== void 0
        ? B
        : "complete";
    let J = "";
    let Q = "";
    const H = Z === "extended" ? "-" : "";
    const x = Z === "extended" ? ":" : "";
    if (j !== "time") {
      const A = b(U.getDate(), 2);
      const E = b(U.getMonth() + 1, 2);
      const T = b(U.getFullYear(), 4);
      J = "".concat(T).concat(H).concat(E).concat(H).concat(A);
    }
    if (j !== "date") {
      const I = U.getTimezoneOffset();
      if (I !== 0) {
        const z = Math.abs(I);
        const Y = b(Math.trunc(z / 60), 2);
        const W = b(z % 60, 2);
        const R = I < 0 ? "+" : "-";
        Q = "".concat(R).concat(Y, ":").concat(W);
      } else Q = "Z";
      const m = b(U.getHours(), 2);
      const l = b(U.getMinutes(), 2);
      const r = b(U.getSeconds(), 2);
      const o = J === "" ? "" : "T";
      const jG = [m, l, r].join(x);
      J = "".concat(J).concat(o).concat(jG).concat(Q);
    }
    return J;
  }
  function LB(G, X) {
    let K;
    let B;
    const U = q(G);
    if (!qG(U)) throw new RangeError("Invalid time value");
    const Z =
      (K = X === null || X === void 0 ? void 0 : X.format) !== null &&
      K !== void 0
        ? K
        : "extended";
    const j =
      (B = X === null || X === void 0 ? void 0 : X.representation) !== null &&
      B !== void 0
        ? B
        : "complete";
    let J = "";
    const Q = Z === "extended" ? "-" : "";
    const H = Z === "extended" ? ":" : "";
    if (j !== "time") {
      const x = b(U.getDate(), 2);
      const A = b(U.getMonth() + 1, 2);
      const E = b(U.getFullYear(), 4);
      J = "".concat(E).concat(Q).concat(A).concat(Q).concat(x);
    }
    if (j !== "date") {
      const T = b(U.getHours(), 2);
      const I = b(U.getMinutes(), 2);
      const z = b(U.getSeconds(), 2);
      const Y = J === "" ? "" : " ";
      J = ""
        .concat(J)
        .concat(Y)
        .concat(T)
        .concat(H)
        .concat(I)
        .concat(H)
        .concat(z);
    }
    return J;
  }
  function $B(G) {
    const X = G.years;
    const K = X === void 0 ? 0 : X;
    const B = G.months;
    const U = B === void 0 ? 0 : B;
    const Z = G.days;
    const j = Z === void 0 ? 0 : Z;
    const J = G.hours;
    const Q = J === void 0 ? 0 : J;
    const H = G.minutes;
    const x = H === void 0 ? 0 : H;
    const A = G.seconds;
    const E = A === void 0 ? 0 : A;
    return "P"
      .concat(K, "Y")
      .concat(U, "M")
      .concat(j, "DT")
      .concat(Q, "H")
      .concat(x, "M")
      .concat(E, "S");
  }
  function PB(G, X) {
    let K;
    const B = q(G);
    if (!qG(B)) throw new RangeError("Invalid time value");
    const U =
      (K = X === null || X === void 0 ? void 0 : X.fractionDigits) !== null &&
      K !== void 0
        ? K
        : 0;
    const Z = b(B.getDate(), 2);
    const j = b(B.getMonth() + 1, 2);
    const J = B.getFullYear();
    const Q = b(B.getHours(), 2);
    const H = b(B.getMinutes(), 2);
    const x = b(B.getSeconds(), 2);
    let A = "";
    if (U > 0) {
      const E = B.getMilliseconds();
      const T = Math.trunc(E * Math.pow(10, U - 3));
      A = `.${b(T, U)}`;
    }
    let I = "";
    const z = B.getTimezoneOffset();
    if (z !== 0) {
      const Y = Math.abs(z);
      const W = b(Math.trunc(Y / 60), 2);
      const R = b(Y % 60, 2);
      const m = z < 0 ? "+" : "-";
      I = "".concat(m).concat(W, ":").concat(R);
    } else I = "Z";
    return ""
      .concat(J, "-")
      .concat(j, "-")
      .concat(Z, "T")
      .concat(Q, ":")
      .concat(H, ":")
      .concat(x)
      .concat(A)
      .concat(I);
  }
  function DB(G) {
    const X = q(G);
    if (!qG(X)) throw new RangeError("Invalid time value");
    const K = vB[X.getUTCDay()];
    const B = b(X.getUTCDate(), 2);
    const U = OB[X.getUTCMonth()];
    const Z = X.getUTCFullYear();
    const j = b(X.getUTCHours(), 2);
    const J = b(X.getUTCMinutes(), 2);
    const Q = b(X.getUTCSeconds(), 2);
    return ""
      .concat(K, ", ")
      .concat(B, " ")
      .concat(U, " ")
      .concat(Z, " ")
      .concat(j, ":")
      .concat(J, ":")
      .concat(Q, " GMT");
  }
  var vB = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var OB = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  function SB(G, X, K) {
    let B;
    let U;
    let Z;
    let j;
    let J;
    let Q;
    let H;
    let x;
    const A = q(G);
    const E = q(X);
    const T = _();
    const I =
      (B =
        (U = K === null || K === void 0 ? void 0 : K.locale) !== null &&
        U !== void 0
          ? U
          : T.locale) !== null && B !== void 0
        ? B
        : TG;
    const z =
      (Z =
        (j =
          (J =
            (Q = K === null || K === void 0 ? void 0 : K.weekStartsOn) !==
              null && Q !== void 0
              ? Q
              : K === null ||
                  K === void 0 ||
                  (H = K.locale) === null ||
                  H === void 0 ||
                  (H = H.options) === null ||
                  H === void 0
                ? void 0
                : H.weekStartsOn) !== null && J !== void 0
            ? J
            : T.weekStartsOn) !== null && j !== void 0
          ? j
          : (x = T.locale) === null ||
              x === void 0 ||
              (x = x.options) === null ||
              x === void 0
            ? void 0
            : x.weekStartsOn) !== null && Z !== void 0
        ? Z
        : 0;
    const Y = KG(A, E);
    if (isNaN(Y)) throw new RangeError("Invalid time value");
    let W;
    if (Y < -6) W = "other";
    else if (Y < -1) W = "lastWeek";
    else if (Y < 0) W = "yesterday";
    else if (Y < 1) W = "today";
    else if (Y < 2) W = "tomorrow";
    else if (Y < 7) W = "nextWeek";
    else W = "other";
    const R = I.formatRelative(W, A, E, { locale: I, weekStartsOn: z });
    return YK(A, R, { locale: I, weekStartsOn: z });
  }
  function yB(G) {
    return q(G * 1000);
  }
  function NX(G) {
    const X = q(G);
    const K = X.getDate();
    return K;
  }
  function oG(G) {
    const X = q(G);
    const K = X.getDay();
    return K;
  }
  function VX(G) {
    const X = q(G);
    const K = X.getFullYear();
    const B = X.getMonth();
    const U = M(G, 0);
    return U.setFullYear(K, B + 1, 0), U.setHours(0, 0, 0, 0), U.getDate();
  }
  function EX(G) {
    const X = q(G);
    const K = X.getFullYear();
    return K % 400 === 0 || (K % 4 === 0 && K % 100 !== 0);
  }
  function kB(G) {
    const X = q(G);
    if (String(new Date(X)) === "Invalid Date") return NaN;
    return EX(X) ? 366 : 365;
  }
  function hB(G) {
    const X = q(G);
    const K = X.getFullYear();
    const B = Math.floor(K / 10) * 10;
    return B;
  }
  function FX() {
    return Object.assign({}, _());
  }
  function mB(G) {
    const X = q(G);
    const K = X.getHours();
    return K;
  }
  function CX(G) {
    const X = q(G);
    let K = X.getDay();
    if (K === 0) K = 7;
    return K;
  }
  function gB(G) {
    const X = xG(G);
    const K = xG(mG(X, 60));
    const B = +K - +X;
    return Math.round(B / LG);
  }
  function cB(G) {
    const X = q(G);
    const K = X.getMilliseconds();
    return K;
  }
  function fB(G) {
    const X = q(G);
    const K = X.getMinutes();
    return K;
  }
  function pB(G) {
    const X = q(G);
    const K = X.getMonth();
    return K;
  }
  function uB(G, X) {
    const K = [+q(G.start), +q(G.end)].sort((z, Y) => {
      return z - Y;
    });
    const B = SG(K, 2);
    const U = B[0];
    const Z = B[1];
    const j = [+q(X.start), +q(X.end)].sort((z, Y) => {
      return z - Y;
    });
    const J = SG(j, 2);
    const Q = J[0];
    const H = J[1];
    const x = U < H && Q < Z;
    if (!x) return 0;
    const A = Q < U ? U : Q;
    const E = A - i(A);
    const T = H > Z ? Z : H;
    const I = T - i(T);
    return Math.ceil((I - E) / yK);
  }
  function _B(G) {
    const X = q(G);
    const K = X.getSeconds();
    return K;
  }
  function lB(G) {
    const X = q(G);
    const K = X.getTime();
    return K;
  }
  function dB(G) {
    return Math.trunc(+q(G) / 1000);
  }
  function iB(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    let J;
    const Q = _();
    const H =
      (K =
        (B =
          (U =
            (Z = X === null || X === void 0 ? void 0 : X.weekStartsOn) !==
              null && Z !== void 0
              ? Z
              : X === null ||
                  X === void 0 ||
                  (j = X.locale) === null ||
                  j === void 0 ||
                  (j = j.options) === null ||
                  j === void 0
                ? void 0
                : j.weekStartsOn) !== null && U !== void 0
            ? U
            : Q.weekStartsOn) !== null && B !== void 0
          ? B
          : (J = Q.locale) === null ||
              J === void 0 ||
              (J = J.options) === null ||
              J === void 0
            ? void 0
            : J.weekStartsOn) !== null && K !== void 0
        ? K
        : 0;
    const x = NX(G);
    if (isNaN(x)) return NaN;
    const A = oG(iG(G));
    let E = H - A;
    if (E <= 0) E += 7;
    const T = x - E;
    return Math.ceil(T / 7) + 1;
  }
  function wX(G) {
    const X = q(G);
    const K = X.getMonth();
    return X.setFullYear(X.getFullYear(), K + 1, 0), X.setHours(0, 0, 0, 0), X;
  }
  function sB(G, X) {
    return fG(wX(G), iG(G), X) + 1;
  }
  function nB(G) {
    return q(G).getFullYear();
  }
  function rB(G) {
    return Math.trunc(G * CG);
  }
  function oB(G) {
    return Math.trunc(G * hK);
  }
  function aB(G) {
    return Math.trunc(G * hG);
  }
  function eB(G, X, K) {
    const B = q(G);
    if (isNaN(+B)) throw new TypeError("Start date is invalid");
    const U = q(X);
    if (isNaN(+U)) throw new TypeError("End date is invalid");
    if (K !== null && K !== void 0 && K.assertPositive && +B > +U)
      throw new TypeError("End date must be after start date");
    return { start: B, end: U };
  }
  function tB(G) {
    const X = q(G.start);
    const K = q(G.end);
    const B = {};
    const U = GX(K, X);
    if (U) B.years = U;
    const Z = n(X, { years: B.years });
    const j = lG(K, Z);
    if (j) B.months = j;
    const J = n(Z, { months: B.months });
    const Q = AK(K, J);
    if (Q) B.days = Q;
    const H = n(J, { days: B.days });
    const x = uG(K, H);
    if (x) B.hours = x;
    const A = n(H, { hours: B.hours });
    const E = _G(K, A);
    if (E) B.minutes = E;
    const T = n(A, { minutes: B.minutes });
    const I = YG(K, T);
    if (I) B.seconds = I;
    return B;
  }
  function GU(G, X, K) {
    let B, U;
    if (KU(X)) U = X;
    else K = X;
    return new Intl.DateTimeFormat(
      (B = K) === null || B === void 0 ? void 0 : B.locale,
      U,
    ).format(q(G));
  }
  var KU = function G(X) {
    return X !== void 0 && !("locale" in X);
  };
  function XU(G, X, K) {
    let B = 0;
    let U;
    const Z = q(G);
    const j = q(X);
    if (!(K !== null && K !== void 0 && K.unit)) {
      const J = YG(Z, j);
      if (Math.abs(J) < jK) (B = YG(Z, j)), (U = "second");
      else if (Math.abs(J) < hG) (B = _G(Z, j)), (U = "minute");
      else if (Math.abs(J) < JK && Math.abs(KG(Z, j)) < 1)
        (B = uG(Z, j)), (U = "hour");
      else if (Math.abs(J) < K0 && (B = KG(Z, j)) && Math.abs(B) < 7) U = "day";
      else if (Math.abs(J) < pK) (B = fG(Z, j)), (U = "week");
      else if (Math.abs(J) < X0) (B = gG(Z, j)), (U = "month");
      else if (Math.abs(J) < fK)
        if (cG(Z, j) < 4) (B = cG(Z, j)), (U = "quarter");
        else (B = PG(Z, j)), (U = "year");
      else (B = PG(Z, j)), (U = "year");
    } else if (
      ((U = K === null || K === void 0 ? void 0 : K.unit), U === "second")
    )
      B = YG(Z, j);
    else if (U === "minute") B = _G(Z, j);
    else if (U === "hour") B = uG(Z, j);
    else if (U === "day") B = KG(Z, j);
    else if (U === "week") B = fG(Z, j);
    else if (U === "month") B = gG(Z, j);
    else if (U === "quarter") B = cG(Z, j);
    else if (U === "year") B = PG(Z, j);
    const Q = new Intl.RelativeTimeFormat(
      K === null || K === void 0 ? void 0 : K.locale,
      {
        localeMatcher: K === null || K === void 0 ? void 0 : K.localeMatcher,
        numeric: (K === null || K === void 0 ? void 0 : K.numeric) || "auto",
        style: K === null || K === void 0 ? void 0 : K.style,
      },
    );
    return Q.format(B, U);
  }
  function BU(G, X) {
    const K = q(G);
    const B = q(X);
    return K.getTime() > B.getTime();
  }
  function UU(G, X) {
    const K = q(G);
    const B = q(X);
    return +K < +B;
  }
  function ZU(G, X) {
    const K = q(G);
    const B = q(X);
    return +K === +B;
  }
  function jU(G, X, K) {
    const B = new Date(G, X, K);
    return B.getFullYear() === G && B.getMonth() === X && B.getDate() === K;
  }
  function JU(G) {
    return q(G).getDate() === 1;
  }
  function qU(G) {
    return q(G).getDay() === 5;
  }
  function QU(G) {
    return +q(G) > Date.now();
  }
  function IX(G, X) {
    const K = X instanceof Date ? M(X, 0) : new X(0);
    return (
      K.setFullYear(G.getFullYear(), G.getMonth(), G.getDate()),
      K.setHours(
        G.getHours(),
        G.getMinutes(),
        G.getSeconds(),
        G.getMilliseconds(),
      ),
      K
    );
  }
  const HU = 10;
  const bX = (function () {
    function G() {
      L(this, G), F(this, "subPriority", 0);
    }
    return (
      $(G, [
        {
          key: "validate",
          value: function X(K, B) {
            return !0;
          },
        },
      ]),
      G
    );
  })();
  const xU = (function (G) {
    D(X, G);
    function X(K, B, U, Z, j) {
      let J;
      if (
        (L(this, X),
        (J = P(this, X)),
        (J.value = K),
        (J.validateValue = B),
        (J.setValue = U),
        (J.priority = Z),
        j)
      )
        J.subPriority = j;
      return J;
    }
    return (
      $(X, [
        {
          key: "validate",
          value: function K(B, U) {
            return this.validateValue(B, this.value, U);
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return this.setValue(B, U, this.value, Z);
          },
        },
      ]),
      X
    );
  })(bX);
  const AU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", HU),
        F(C(K), "subPriority", -1),
        K
      );
    }
    return (
      $(X, [
        {
          key: "set",
          value: function K(B, U) {
            if (U.timestampIsSet) return B;
            return M(B, IX(B, Date));
          },
        },
      ]),
      X
    );
  })(bX);
  const v = (function () {
    function G() {
      L(this, G);
    }
    return (
      $(G, [
        {
          key: "run",
          value: function X(K, B, U, Z) {
            const j = this.parse(K, B, U, Z);
            if (!j) return null;
            return {
              setter: new xU(
                j.value,
                this.validate,
                this.set,
                this.priority,
                this.subPriority,
              ),
              rest: j.rest,
            };
          },
        },
        {
          key: "validate",
          value: function X(K, B, U) {
            return !0;
          },
        },
      ]),
      G
    );
  })();
  const NU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 140),
        F(C(K), "incompatibleTokens", ["R", "u", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "G":
              case "GG":
              case "GGG":
                return (
                  Z.era(B, { width: "abbreviated" }) ||
                  Z.era(B, { width: "narrow" })
                );
              case "GGGGG":
                return Z.era(B, { width: "narrow" });
              case "GGGG":
              default:
                return (
                  Z.era(B, { width: "wide" }) ||
                  Z.era(B, { width: "abbreviated" }) ||
                  Z.era(B, { width: "narrow" })
                );
            }
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return (
              (U.era = Z), B.setFullYear(Z, 0, 1), B.setHours(0, 0, 0, 0), B
            );
          },
        },
      ]),
      X
    );
  })(v);
  const k = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/,
  };
  const UG = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
  };
  function h(G, X) {
    if (!G) return G;
    return { value: X(G.value), rest: G.rest };
  }
  function S(G, X) {
    const K = X.match(G);
    if (!K) return null;
    return { value: parseInt(K[0], 10), rest: X.slice(K[0].length) };
  }
  function ZG(G, X) {
    const K = X.match(G);
    if (!K) return null;
    if (K[0] === "Z") return { value: 0, rest: X.slice(1) };
    const B = K[1] === "+" ? 1 : -1;
    const U = K[2] ? parseInt(K[2], 10) : 0;
    const Z = K[3] ? parseInt(K[3], 10) : 0;
    const j = K[5] ? parseInt(K[5], 10) : 0;
    return {
      value: B * (U * CG + Z * JG + j * ZK),
      rest: X.slice(K[0].length),
    };
  }
  function MX(G) {
    return S(k.anyDigitsSigned, G);
  }
  function y(G, X) {
    switch (G) {
      case 1:
        return S(k.singleDigit, X);
      case 2:
        return S(k.twoDigits, X);
      case 3:
        return S(k.threeDigits, X);
      case 4:
        return S(k.fourDigits, X);
      default:
        return S(new RegExp(`^\\d{1,${G}}`), X);
    }
  }
  function aG(G, X) {
    switch (G) {
      case 1:
        return S(k.singleDigitSigned, X);
      case 2:
        return S(k.twoDigitsSigned, X);
      case 3:
        return S(k.threeDigitsSigned, X);
      case 4:
        return S(k.fourDigitsSigned, X);
      default:
        return S(new RegExp(`^-?\\d{1,${G}}`), X);
    }
  }
  function TK(G) {
    switch (G) {
      case "morning":
        return 4;
      case "evening":
        return 17;
      case "pm":
      case "noon":
      case "afternoon":
        return 12;
      case "am":
      case "midnight":
      case "night":
      default:
        return 0;
    }
  }
  function YX(G, X) {
    const K = X > 0;
    const B = K ? X : 1 - X;
    let U;
    if (B <= 50) U = G || 100;
    else {
      const Z = B + 50;
      const j = Math.trunc(Z / 100) * 100;
      const J = G >= Z % 100;
      U = G + j - (J ? 100 : 0);
    }
    return K ? U : 1 - U;
  }
  function TX(G) {
    return G % 400 === 0 || (G % 4 === 0 && G % 100 !== 0);
  }
  const VU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 130),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "u",
          "w",
          "I",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            const j = function J(Q) {
              return { year: Q, isTwoDigitYear: U === "yy" };
            };
            switch (U) {
              case "y":
                return h(y(4, B), j);
              case "yo":
                return h(Z.ordinalNumber(B, { unit: "year" }), j);
              default:
                return h(y(U.length, B), j);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U.isTwoDigitYear || U.year > 0;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            const j = B.getFullYear();
            if (Z.isTwoDigitYear) {
              const J = YX(Z.year, j);
              return B.setFullYear(J, 0, 1), B.setHours(0, 0, 0, 0), B;
            }
            const Q = !("era" in U) || U.era === 1 ? Z.year : 1 - Z.year;
            return B.setFullYear(Q, 0, 1), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const EU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 130),
        F(C(K), "incompatibleTokens", [
          "y",
          "R",
          "u",
          "Q",
          "q",
          "M",
          "L",
          "I",
          "d",
          "D",
          "i",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            const j = function J(Q) {
              return { year: Q, isTwoDigitYear: U === "YY" };
            };
            switch (U) {
              case "Y":
                return h(y(4, B), j);
              case "Yo":
                return h(Z.ordinalNumber(B, { unit: "year" }), j);
              default:
                return h(y(U.length, B), j);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U.isTwoDigitYear || U.year > 0;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z, j) {
            const J = sG(B, j);
            if (Z.isTwoDigitYear) {
              const Q = YX(Z.year, J);
              return (
                B.setFullYear(Q, 0, j.firstWeekContainsDate),
                B.setHours(0, 0, 0, 0),
                f(B, j)
              );
            }
            const H = !("era" in U) || U.era === 1 ? Z.year : 1 - Z.year;
            return (
              B.setFullYear(H, 0, j.firstWeekContainsDate),
              B.setHours(0, 0, 0, 0),
              f(B, j)
            );
          },
        },
      ]),
      X
    );
  })(v);
  const FU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 130),
        F(C(K), "incompatibleTokens", [
          "G",
          "y",
          "Y",
          "u",
          "Q",
          "q",
          "M",
          "L",
          "w",
          "d",
          "D",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U) {
            if (U === "R") return aG(4, B);
            return aG(U.length, B);
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            const j = M(B, 0);
            return j.setFullYear(Z, 0, 4), j.setHours(0, 0, 0, 0), GG(j);
          },
        },
      ]),
      X
    );
  })(v);
  const CU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 130),
        F(C(K), "incompatibleTokens", [
          "G",
          "y",
          "Y",
          "R",
          "w",
          "I",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U) {
            if (U === "u") return aG(4, B);
            return aG(U.length, B);
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setFullYear(Z, 0, 1), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const wU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 120),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "q",
          "M",
          "L",
          "w",
          "I",
          "d",
          "D",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "Q":
              case "QQ":
                return y(U.length, B);
              case "Qo":
                return Z.ordinalNumber(B, { unit: "quarter" });
              case "QQQ":
                return (
                  Z.quarter(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) || Z.quarter(B, { width: "narrow", context: "formatting" })
                );
              case "QQQQQ":
                return Z.quarter(B, { width: "narrow", context: "formatting" });
              case "QQQQ":
              default:
                return (
                  Z.quarter(B, { width: "wide", context: "formatting" }) ||
                  Z.quarter(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.quarter(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 4;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMonth((Z - 1) * 3, 1), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const IU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 120),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "Q",
          "M",
          "L",
          "w",
          "I",
          "d",
          "D",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "q":
              case "qq":
                return y(U.length, B);
              case "qo":
                return Z.ordinalNumber(B, { unit: "quarter" });
              case "qqq":
                return (
                  Z.quarter(B, {
                    width: "abbreviated",
                    context: "standalone",
                  }) || Z.quarter(B, { width: "narrow", context: "standalone" })
                );
              case "qqqqq":
                return Z.quarter(B, { width: "narrow", context: "standalone" });
              case "qqqq":
              default:
                return (
                  Z.quarter(B, { width: "wide", context: "standalone" }) ||
                  Z.quarter(B, {
                    width: "abbreviated",
                    context: "standalone",
                  }) ||
                  Z.quarter(B, { width: "narrow", context: "standalone" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 4;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMonth((Z - 1) * 3, 1), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const bU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "q",
          "Q",
          "L",
          "w",
          "I",
          "D",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        F(C(K), "priority", 110),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            const j = function J(Q) {
              return Q - 1;
            };
            switch (U) {
              case "M":
                return h(S(k.month, B), j);
              case "MM":
                return h(y(2, B), j);
              case "Mo":
                return h(Z.ordinalNumber(B, { unit: "month" }), j);
              case "MMM":
                return (
                  Z.month(B, { width: "abbreviated", context: "formatting" }) ||
                  Z.month(B, { width: "narrow", context: "formatting" })
                );
              case "MMMMM":
                return Z.month(B, { width: "narrow", context: "formatting" });
              case "MMMM":
              default:
                return (
                  Z.month(B, { width: "wide", context: "formatting" }) ||
                  Z.month(B, { width: "abbreviated", context: "formatting" }) ||
                  Z.month(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 11;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMonth(Z, 1), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const MU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 110),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "q",
          "Q",
          "M",
          "w",
          "I",
          "D",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            const j = function J(Q) {
              return Q - 1;
            };
            switch (U) {
              case "L":
                return h(S(k.month, B), j);
              case "LL":
                return h(y(2, B), j);
              case "Lo":
                return h(Z.ordinalNumber(B, { unit: "month" }), j);
              case "LLL":
                return (
                  Z.month(B, { width: "abbreviated", context: "standalone" }) ||
                  Z.month(B, { width: "narrow", context: "standalone" })
                );
              case "LLLLL":
                return Z.month(B, { width: "narrow", context: "standalone" });
              case "LLLL":
              default:
                return (
                  Z.month(B, { width: "wide", context: "standalone" }) ||
                  Z.month(B, { width: "abbreviated", context: "standalone" }) ||
                  Z.month(B, { width: "narrow", context: "standalone" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 11;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMonth(Z, 1), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  function zX(G, X, K) {
    const B = q(G);
    const U = IK(B, K) - X;
    return B.setDate(B.getDate() - U * 7), B;
  }
  const YU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 100),
        F(C(K), "incompatibleTokens", [
          "y",
          "R",
          "u",
          "q",
          "Q",
          "M",
          "L",
          "I",
          "d",
          "D",
          "i",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "w":
                return S(k.week, B);
              case "wo":
                return Z.ordinalNumber(B, { unit: "week" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 53;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z, j) {
            return f(zX(B, Z, j), j);
          },
        },
      ]),
      X
    );
  })(v);
  function WX(G, X) {
    const K = q(G);
    const B = wK(K) - X;
    return K.setDate(K.getDate() - B * 7), K;
  }
  const TU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 100),
        F(C(K), "incompatibleTokens", [
          "y",
          "Y",
          "u",
          "q",
          "Q",
          "M",
          "L",
          "w",
          "d",
          "D",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "I":
                return S(k.week, B);
              case "Io":
                return Z.ordinalNumber(B, { unit: "week" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 53;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return GG(WX(B, Z));
          },
        },
      ]),
      X
    );
  })(v);
  const zU = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const WU = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const RU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 90),
        F(C(K), "subPriority", 1),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "q",
          "Q",
          "w",
          "I",
          "D",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "d":
                return S(k.date, B);
              case "do":
                return Z.ordinalNumber(B, { unit: "date" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            const Z = B.getFullYear();
            const j = TX(Z);
            const J = B.getMonth();
            if (j) return U >= 1 && U <= WU[J];
            else return U >= 1 && U <= zU[J];
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setDate(Z), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const LU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 90),
        F(C(K), "subpriority", 1),
        F(C(K), "incompatibleTokens", [
          "Y",
          "R",
          "q",
          "Q",
          "M",
          "L",
          "w",
          "I",
          "d",
          "E",
          "i",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "D":
              case "DD":
                return S(k.dayOfYear, B);
              case "Do":
                return Z.ordinalNumber(B, { unit: "date" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            const Z = B.getFullYear();
            const j = TX(Z);
            if (j) return U >= 1 && U <= 366;
            else return U >= 1 && U <= 365;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMonth(0, Z), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  function eG(G, X, K) {
    let B;
    let U;
    let Z;
    let j;
    let J;
    let Q;
    const H = _();
    const x =
      (B =
        (U =
          (Z =
            (j = K === null || K === void 0 ? void 0 : K.weekStartsOn) !==
              null && j !== void 0
              ? j
              : K === null ||
                  K === void 0 ||
                  (J = K.locale) === null ||
                  J === void 0 ||
                  (J = J.options) === null ||
                  J === void 0
                ? void 0
                : J.weekStartsOn) !== null && Z !== void 0
            ? Z
            : H.weekStartsOn) !== null && U !== void 0
          ? U
          : (Q = H.locale) === null ||
              Q === void 0 ||
              (Q = Q.options) === null ||
              Q === void 0
            ? void 0
            : Q.weekStartsOn) !== null && B !== void 0
        ? B
        : 0;
    const A = q(G);
    const E = A.getDay();
    const T = X % 7;
    const I = (T + 7) % 7;
    const z = 7 - x;
    const Y =
      X < 0 || X > 6 ? X - ((E + z) % 7) : ((I + z) % 7) - ((E + z) % 7);
    return u(A, Y);
  }
  const $U = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 90),
        F(C(K), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "E":
              case "EE":
              case "EEE":
                return (
                  Z.day(B, { width: "abbreviated", context: "formatting" }) ||
                  Z.day(B, { width: "short", context: "formatting" }) ||
                  Z.day(B, { width: "narrow", context: "formatting" })
                );
              case "EEEEE":
                return Z.day(B, { width: "narrow", context: "formatting" });
              case "EEEEEE":
                return (
                  Z.day(B, { width: "short", context: "formatting" }) ||
                  Z.day(B, { width: "narrow", context: "formatting" })
                );
              case "EEEE":
              default:
                return (
                  Z.day(B, { width: "wide", context: "formatting" }) ||
                  Z.day(B, { width: "abbreviated", context: "formatting" }) ||
                  Z.day(B, { width: "short", context: "formatting" }) ||
                  Z.day(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 6;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z, j) {
            return (B = eG(B, Z, j)), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const PU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 90),
        F(C(K), "incompatibleTokens", [
          "y",
          "R",
          "u",
          "q",
          "Q",
          "M",
          "L",
          "I",
          "d",
          "D",
          "E",
          "i",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z, j) {
            const J = function Q(H) {
              const x = Math.floor((H - 1) / 7) * 7;
              return ((H + j.weekStartsOn + 6) % 7) + x;
            };
            switch (U) {
              case "e":
              case "ee":
                return h(y(U.length, B), J);
              case "eo":
                return h(Z.ordinalNumber(B, { unit: "day" }), J);
              case "eee":
                return (
                  Z.day(B, { width: "abbreviated", context: "formatting" }) ||
                  Z.day(B, { width: "short", context: "formatting" }) ||
                  Z.day(B, { width: "narrow", context: "formatting" })
                );
              case "eeeee":
                return Z.day(B, { width: "narrow", context: "formatting" });
              case "eeeeee":
                return (
                  Z.day(B, { width: "short", context: "formatting" }) ||
                  Z.day(B, { width: "narrow", context: "formatting" })
                );
              case "eeee":
              default:
                return (
                  Z.day(B, { width: "wide", context: "formatting" }) ||
                  Z.day(B, { width: "abbreviated", context: "formatting" }) ||
                  Z.day(B, { width: "short", context: "formatting" }) ||
                  Z.day(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 6;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z, j) {
            return (B = eG(B, Z, j)), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const DU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 90),
        F(C(K), "incompatibleTokens", [
          "y",
          "R",
          "u",
          "q",
          "Q",
          "M",
          "L",
          "I",
          "d",
          "D",
          "E",
          "i",
          "e",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z, j) {
            const J = function Q(H) {
              const x = Math.floor((H - 1) / 7) * 7;
              return ((H + j.weekStartsOn + 6) % 7) + x;
            };
            switch (U) {
              case "c":
              case "cc":
                return h(y(U.length, B), J);
              case "co":
                return h(Z.ordinalNumber(B, { unit: "day" }), J);
              case "ccc":
                return (
                  Z.day(B, { width: "abbreviated", context: "standalone" }) ||
                  Z.day(B, { width: "short", context: "standalone" }) ||
                  Z.day(B, { width: "narrow", context: "standalone" })
                );
              case "ccccc":
                return Z.day(B, { width: "narrow", context: "standalone" });
              case "cccccc":
                return (
                  Z.day(B, { width: "short", context: "standalone" }) ||
                  Z.day(B, { width: "narrow", context: "standalone" })
                );
              case "cccc":
              default:
                return (
                  Z.day(B, { width: "wide", context: "standalone" }) ||
                  Z.day(B, { width: "abbreviated", context: "standalone" }) ||
                  Z.day(B, { width: "short", context: "standalone" }) ||
                  Z.day(B, { width: "narrow", context: "standalone" })
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 6;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z, j) {
            return (B = eG(B, Z, j)), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  function RX(G, X) {
    const K = q(G);
    const B = CX(K);
    const U = X - B;
    return u(K, U);
  }
  const vU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 90),
        F(C(K), "incompatibleTokens", [
          "y",
          "Y",
          "u",
          "q",
          "Q",
          "M",
          "L",
          "w",
          "d",
          "D",
          "E",
          "e",
          "c",
          "t",
          "T",
        ]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            const j = function J(Q) {
              if (Q === 0) return 7;
              return Q;
            };
            switch (U) {
              case "i":
              case "ii":
                return y(U.length, B);
              case "io":
                return Z.ordinalNumber(B, { unit: "day" });
              case "iii":
                return h(
                  Z.day(B, { width: "abbreviated", context: "formatting" }) ||
                    Z.day(B, { width: "short", context: "formatting" }) ||
                    Z.day(B, { width: "narrow", context: "formatting" }),
                  j,
                );
              case "iiiii":
                return h(
                  Z.day(B, { width: "narrow", context: "formatting" }),
                  j,
                );
              case "iiiiii":
                return h(
                  Z.day(B, { width: "short", context: "formatting" }) ||
                    Z.day(B, { width: "narrow", context: "formatting" }),
                  j,
                );
              case "iiii":
              default:
                return h(
                  Z.day(B, { width: "wide", context: "formatting" }) ||
                    Z.day(B, { width: "abbreviated", context: "formatting" }) ||
                    Z.day(B, { width: "short", context: "formatting" }) ||
                    Z.day(B, { width: "narrow", context: "formatting" }),
                  j,
                );
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 7;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return (B = RX(B, Z)), B.setHours(0, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const OU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 80),
        F(C(K), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "a":
              case "aa":
              case "aaa":
                return (
                  Z.dayPeriod(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.dayPeriod(B, { width: "narrow", context: "formatting" })
                );
              case "aaaaa":
                return Z.dayPeriod(B, {
                  width: "narrow",
                  context: "formatting",
                });
              case "aaaa":
              default:
                return (
                  Z.dayPeriod(B, { width: "wide", context: "formatting" }) ||
                  Z.dayPeriod(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.dayPeriod(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setHours(TK(Z), 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const SU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 80),
        F(C(K), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "b":
              case "bb":
              case "bbb":
                return (
                  Z.dayPeriod(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.dayPeriod(B, { width: "narrow", context: "formatting" })
                );
              case "bbbbb":
                return Z.dayPeriod(B, {
                  width: "narrow",
                  context: "formatting",
                });
              case "bbbb":
              default:
                return (
                  Z.dayPeriod(B, { width: "wide", context: "formatting" }) ||
                  Z.dayPeriod(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.dayPeriod(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setHours(TK(Z), 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const yU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 80),
        F(C(K), "incompatibleTokens", ["a", "b", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "B":
              case "BB":
              case "BBB":
                return (
                  Z.dayPeriod(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.dayPeriod(B, { width: "narrow", context: "formatting" })
                );
              case "BBBBB":
                return Z.dayPeriod(B, {
                  width: "narrow",
                  context: "formatting",
                });
              case "BBBB":
              default:
                return (
                  Z.dayPeriod(B, { width: "wide", context: "formatting" }) ||
                  Z.dayPeriod(B, {
                    width: "abbreviated",
                    context: "formatting",
                  }) ||
                  Z.dayPeriod(B, { width: "narrow", context: "formatting" })
                );
            }
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setHours(TK(Z), 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const kU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 70),
        F(C(K), "incompatibleTokens", ["H", "K", "k", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "h":
                return S(k.hour12h, B);
              case "ho":
                return Z.ordinalNumber(B, { unit: "hour" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 12;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            const j = B.getHours() >= 12;
            if (j && Z < 12) B.setHours(Z + 12, 0, 0, 0);
            else if (!j && Z === 12) B.setHours(0, 0, 0, 0);
            else B.setHours(Z, 0, 0, 0);
            return B;
          },
        },
      ]),
      X
    );
  })(v);
  const hU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 70),
        F(C(K), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "H":
                return S(k.hour23h, B);
              case "Ho":
                return Z.ordinalNumber(B, { unit: "hour" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 23;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setHours(Z, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const mU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 70),
        F(C(K), "incompatibleTokens", ["h", "H", "k", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "K":
                return S(k.hour11h, B);
              case "Ko":
                return Z.ordinalNumber(B, { unit: "hour" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 11;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            const j = B.getHours() >= 12;
            if (j && Z < 12) B.setHours(Z + 12, 0, 0, 0);
            else B.setHours(Z, 0, 0, 0);
            return B;
          },
        },
      ]),
      X
    );
  })(v);
  const gU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 70),
        F(C(K), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "k":
                return S(k.hour24h, B);
              case "ko":
                return Z.ordinalNumber(B, { unit: "hour" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 1 && U <= 24;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            const j = Z <= 24 ? Z % 24 : Z;
            return B.setHours(j, 0, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const cU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 60),
        F(C(K), "incompatibleTokens", ["t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "m":
                return S(k.minute, B);
              case "mo":
                return Z.ordinalNumber(B, { unit: "minute" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 59;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMinutes(Z, 0, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const fU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 50),
        F(C(K), "incompatibleTokens", ["t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U, Z) {
            switch (U) {
              case "s":
                return S(k.second, B);
              case "so":
                return Z.ordinalNumber(B, { unit: "second" });
              default:
                return y(U.length, B);
            }
          },
        },
        {
          key: "validate",
          value: function K(B, U) {
            return U >= 0 && U <= 59;
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setSeconds(Z, 0), B;
          },
        },
      ]),
      X
    );
  })(v);
  const pU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 30),
        F(C(K), "incompatibleTokens", ["t", "T"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U) {
            const Z = function j(J) {
              return Math.trunc(J * Math.pow(10, -U.length + 3));
            };
            return h(y(U.length, B), Z);
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return B.setMilliseconds(Z), B;
          },
        },
      ]),
      X
    );
  })(v);
  const uU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 10),
        F(C(K), "incompatibleTokens", ["t", "T", "x"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U) {
            switch (U) {
              case "X":
                return ZG(UG.basicOptionalMinutes, B);
              case "XX":
                return ZG(UG.basic, B);
              case "XXXX":
                return ZG(UG.basicOptionalSeconds, B);
              case "XXXXX":
                return ZG(UG.extendedOptionalSeconds, B);
              case "XXX":
              default:
                return ZG(UG.extended, B);
            }
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            if (U.timestampIsSet) return B;
            return M(B, B.getTime() - i(B) - Z);
          },
        },
      ]),
      X
    );
  })(v);
  const _U = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 10),
        F(C(K), "incompatibleTokens", ["t", "T", "X"]),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B, U) {
            switch (U) {
              case "x":
                return ZG(UG.basicOptionalMinutes, B);
              case "xx":
                return ZG(UG.basic, B);
              case "xxxx":
                return ZG(UG.basicOptionalSeconds, B);
              case "xxxxx":
                return ZG(UG.extendedOptionalSeconds, B);
              case "xxx":
              default:
                return ZG(UG.extended, B);
            }
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            if (U.timestampIsSet) return B;
            return M(B, B.getTime() - i(B) - Z);
          },
        },
      ]),
      X
    );
  })(v);
  const lU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 40),
        F(C(K), "incompatibleTokens", "*"),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B) {
            return MX(B);
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return [M(B, Z * 1000), { timestampIsSet: !0 }];
          },
        },
      ]),
      X
    );
  })(v);
  const dU = (function (G) {
    D(X, G);
    function X() {
      let K;
      L(this, X);
      for (var B = arguments.length, U = new Array(B), Z = 0; Z < B; Z++)
        U[Z] = arguments[Z];
      return (
        (K = P(this, X, [].concat(U))),
        F(C(K), "priority", 20),
        F(C(K), "incompatibleTokens", "*"),
        K
      );
    }
    return (
      $(X, [
        {
          key: "parse",
          value: function K(B) {
            return MX(B);
          },
        },
        {
          key: "set",
          value: function K(B, U, Z) {
            return [M(B, Z), { timestampIsSet: !0 }];
          },
        },
      ]),
      X
    );
  })(v);
  var LX = {
    G: new NU(),
    y: new VU(),
    Y: new EU(),
    R: new FU(),
    u: new CU(),
    Q: new wU(),
    q: new IU(),
    M: new bU(),
    L: new MU(),
    w: new YU(),
    I: new TU(),
    d: new RU(),
    D: new LU(),
    E: new $U(),
    e: new PU(),
    c: new DU(),
    i: new vU(),
    a: new OU(),
    b: new SU(),
    B: new yU(),
    h: new kU(),
    H: new hU(),
    K: new mU(),
    k: new gU(),
    m: new cU(),
    s: new fU(),
    S: new pU(),
    X: new uU(),
    x: new _U(),
    t: new lU(),
    T: new dU(),
  };
  function $X(G, X, K, B) {
    let U;
    let Z;
    let j;
    let J;
    let Q;
    let H;
    let x;
    let A;
    let E;
    let T;
    let I;
    let z;
    let Y;
    let W;
    const R = FX();
    const m =
      (U =
        (Z = B === null || B === void 0 ? void 0 : B.locale) !== null &&
        Z !== void 0
          ? Z
          : R.locale) !== null && U !== void 0
        ? U
        : TG;
    const l =
      (j =
        (J =
          (Q =
            (H =
              B === null || B === void 0 ? void 0 : B.firstWeekContainsDate) !==
              null && H !== void 0
              ? H
              : B === null ||
                  B === void 0 ||
                  (x = B.locale) === null ||
                  x === void 0 ||
                  (x = x.options) === null ||
                  x === void 0
                ? void 0
                : x.firstWeekContainsDate) !== null && Q !== void 0
            ? Q
            : R.firstWeekContainsDate) !== null && J !== void 0
          ? J
          : (A = R.locale) === null ||
              A === void 0 ||
              (A = A.options) === null ||
              A === void 0
            ? void 0
            : A.firstWeekContainsDate) !== null && j !== void 0
        ? j
        : 1;
    const r =
      (E =
        (T =
          (I =
            (z = B === null || B === void 0 ? void 0 : B.weekStartsOn) !==
              null && z !== void 0
              ? z
              : B === null ||
                  B === void 0 ||
                  (Y = B.locale) === null ||
                  Y === void 0 ||
                  (Y = Y.options) === null ||
                  Y === void 0
                ? void 0
                : Y.weekStartsOn) !== null && I !== void 0
            ? I
            : R.weekStartsOn) !== null && T !== void 0
          ? T
          : (W = R.locale) === null ||
              W === void 0 ||
              (W = W.options) === null ||
              W === void 0
            ? void 0
            : W.weekStartsOn) !== null && E !== void 0
        ? E
        : 0;
    if (X === "")
      if (G === "") return q(K);
      else return M(K, NaN);
    const o = { firstWeekContainsDate: l, weekStartsOn: r, locale: m };
    const jG = [new AU()];
    const p = X.match(nU)
      .map((c) => {
        const O = c[0];
        if (O in rG) {
          const t = rG[O];
          return t(c, m.formatLong);
        }
        return c;
      })
      .join("")
      .match(sU);
    const g = [];
    const EG = nX(p);
    let cX;
    try {
      const oj = function c() {
        let O = cX.value;
        if (
          !(B !== null && B !== void 0 && B.useAdditionalWeekYearTokens) &&
          HX(O)
        )
          MK(O, X, G);
        if (
          !(B !== null && B !== void 0 && B.useAdditionalDayOfYearTokens) &&
          QX(O)
        )
          MK(O, X, G);
        const t = O[0];
        const BK = LX[t];
        if (BK) {
          const _X = BK.incompatibleTokens;
          if (Array.isArray(_X)) {
            const lX = g.find((dX) => {
              return _X.includes(dX.token) || dX.token === t;
            });
            if (lX)
              throw new RangeError(
                "The format string mustn't contain `"
                  .concat(lX.fullToken, "` and `")
                  .concat(O, "` at the same time"),
              );
          } else if (BK.incompatibleTokens === "*" && g.length > 0)
            throw new RangeError(
              "The format string mustn't contain `".concat(
                O,
                "` and any other token at the same time",
              ),
            );
          g.push({ token: t, fullToken: O });
          const DK = BK.run(G, O, m.match, o);
          if (!DK) return { v: M(K, NaN) };
          jG.push(DK.setter), (G = DK.rest);
        } else {
          if (t.match(eU))
            throw new RangeError(
              `Format string contains an unescaped latin alphabet character \`${t}\``,
            );
          if (O === "''") O = "'";
          else if (t === "'") O = iU(O);
          if (G.indexOf(O) === 0) G = G.slice(O.length);
          else return { v: M(K, NaN) };
        }
      };
      let PK;
      for (EG.s(); !(cX = EG.n()).done; ) if (((PK = oj()), PK)) return PK.v;
    } catch (c) {
      EG.e(c);
    } finally {
      EG.f();
    }
    if (G.length > 0 && aU.test(G)) return M(K, NaN);
    const aj = jG
      .map((c) => {
        return c.priority;
      })
      .sort((c, O) => {
        return O - c;
      })
      .filter((c, O, t) => {
        return t.indexOf(c) === O;
      })
      .map((c) => {
        return jG
          .filter((O) => {
            return O.priority === c;
          })
          .sort((O, t) => {
            return t.subPriority - O.subPriority;
          });
      })
      .map((c) => {
        return c[0];
      });
    let WG = q(K);
    if (isNaN(WG.getTime())) return M(K, NaN);
    const fX = {};
    const KK = nX(aj);
    let pX;
    try {
      for (KK.s(); !(pX = KK.n()).done; ) {
        const uX = pX.value;
        if (!uX.validate(WG, o)) return M(K, NaN);
        const XK = uX.set(WG, fX, o);
        if (Array.isArray(XK)) (WG = XK[0]), Object.assign(fX, XK[1]);
        else WG = XK;
      }
    } catch (c) {
      KK.e(c);
    } finally {
      KK.f();
    }
    return M(K, WG);
  }
  var iU = function G(X) {
    return X.match(rU)[1].replace(oU, "'");
  };
  var sU = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
  var nU = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var rU = /^'([^]*?)'?$/;
  var oU = /''/g;
  var aU = /\S/;
  var eU = /[a-zA-Z]/;
  function tU(G, X, K) {
    return qG($X(G, X, new Date(), K));
  }
  function GZ(G) {
    return q(G).getDay() === 1;
  }
  function KZ(G) {
    return +q(G) < Date.now();
  }
  function zK(G) {
    const X = q(G);
    return X.setMinutes(0, 0, 0), X;
  }
  function PX(G, X) {
    const K = zK(G);
    const B = zK(X);
    return +K === +B;
  }
  function WK(G, X, K) {
    const B = f(G, K);
    const U = f(X, K);
    return +B === +U;
  }
  function DX(G, X) {
    return WK(G, X, { weekStartsOn: 1 });
  }
  function XZ(G, X) {
    const K = xG(G);
    const B = xG(X);
    return +K === +B;
  }
  function vX(G, X) {
    const K = dG(G);
    const B = dG(X);
    return +K === +B;
  }
  function OX(G, X) {
    const K = q(G);
    const B = q(X);
    return K.getFullYear() === B.getFullYear() && K.getMonth() === B.getMonth();
  }
  function SX(G, X) {
    const K = wG(G);
    const B = wG(X);
    return +K === +B;
  }
  function RK(G) {
    const X = q(G);
    return X.setMilliseconds(0), X;
  }
  function yX(G, X) {
    const K = RK(G);
    const B = RK(X);
    return +K === +B;
  }
  function kX(G, X) {
    const K = q(G);
    const B = q(X);
    return K.getFullYear() === B.getFullYear();
  }
  function BZ(G) {
    return PX(G, s(G));
  }
  function UZ(G) {
    return DX(G, s(G));
  }
  function ZZ(G) {
    return vX(G, s(G));
  }
  function jZ(G) {
    return OX(G, s(G));
  }
  function JZ(G) {
    return SX(G, s(G));
  }
  function qZ(G) {
    return yX(G, s(G));
  }
  function QZ(G, X) {
    return WK(G, s(G), X);
  }
  function HZ(G) {
    return kX(G, s(G));
  }
  function xZ(G) {
    return q(G).getDay() === 4;
  }
  function AZ(G) {
    return $G(G, s(G));
  }
  function NZ(G) {
    return $G(G, u(s(G), 1));
  }
  function VZ(G) {
    return q(G).getDay() === 2;
  }
  function EZ(G) {
    return q(G).getDay() === 3;
  }
  function FZ(G, X) {
    const K = +q(G);
    const B = [+q(X.start), +q(X.end)].sort((J, Q) => {
      return J - Q;
    });
    const U = SG(B, 2);
    const Z = U[0];
    const j = U[1];
    return K >= Z && K <= j;
  }
  function tG(G, X) {
    return u(G, -X);
  }
  function CZ(G) {
    return $G(G, tG(s(G), 1));
  }
  function wZ(G) {
    const X = q(G);
    const K = X.getFullYear();
    const B = 9 + Math.floor(K / 10) * 10;
    return X.setFullYear(B + 1, 0, 0), X.setHours(0, 0, 0, 0), X;
  }
  function hX(G, X) {
    let K;
    let B;
    let U;
    let Z;
    let j;
    let J;
    const Q = _();
    const H =
      (K =
        (B =
          (U =
            (Z = X === null || X === void 0 ? void 0 : X.weekStartsOn) !==
              null && Z !== void 0
              ? Z
              : X === null ||
                  X === void 0 ||
                  (j = X.locale) === null ||
                  j === void 0 ||
                  (j = j.options) === null ||
                  j === void 0
                ? void 0
                : j.weekStartsOn) !== null && U !== void 0
            ? U
            : Q.weekStartsOn) !== null && B !== void 0
          ? B
          : (J = Q.locale) === null ||
              J === void 0 ||
              (J = J.options) === null ||
              J === void 0
            ? void 0
            : J.weekStartsOn) !== null && K !== void 0
        ? K
        : 0;
    const x = q(G);
    const A = x.getDay();
    const E = (A < H ? -7 : 0) + 6 - (A - H);
    return x.setHours(0, 0, 0, 0), x.setDate(x.getDate() + E), x;
  }
  function IZ(G) {
    return hX(G, { weekStartsOn: 1 });
  }
  function bZ(G) {
    const X = HG(G);
    const K = M(G, 0);
    K.setFullYear(X + 1, 0, 4), K.setHours(0, 0, 0, 0);
    const B = GG(K);
    return B.setDate(B.getDate() - 1), B;
  }
  function MZ(G) {
    const X = q(G);
    const K = X.getMonth();
    const B = K - (K % 3) + 3;
    return X.setMonth(B, 0), X.setHours(0, 0, 0, 0), X;
  }
  function YZ(G) {
    const X = q(G);
    const K = X.getFullYear();
    return X.setFullYear(K + 1, 0, 0), X.setHours(0, 0, 0, 0), X;
  }
  function TZ(G, X) {
    const K = q(G);
    if (!qG(K)) throw new RangeError("Invalid time value");
    const B = X.match(WZ);
    if (!B) return "";
    const U = B.map((Z) => {
      if (Z === "''") return "'";
      const j = Z[0];
      if (j === "'") return zZ(Z);
      const J = BG[j];
      if (J) return J(K, Z);
      if (j.match($Z))
        throw new RangeError(
          `Format string contains an unescaped latin alphabet character \`${j}\``,
        );
      return Z;
    }).join("");
    return U;
  }
  var zZ = function G(X) {
    const K = X.match(RZ);
    if (!K) return X;
    return K[1].replace(LZ, "'");
  };
  var WZ = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
  var RZ = /^'([^]*?)'?$/;
  var LZ = /''/g;
  var $Z = /[a-zA-Z]/;
  function PZ(G) {
    const {
      years: X,
      months: K,
      weeks: B,
      days: U,
      hours: Z,
      minutes: j,
      seconds: J,
    } = G;
    let Q = 0;
    if (X) Q += X * yG;
    if (K) Q += K * (yG / 12);
    if (B) Q += B * 7;
    if (U) Q += U;
    let H = Q * 24 * 60 * 60;
    if (Z) H += Z * 60 * 60;
    if (j) H += j * 60;
    if (J) H += J;
    return Math.trunc(H * 1000);
  }
  function DZ(G) {
    const X = G / CG;
    return Math.trunc(X);
  }
  function vZ(G) {
    const X = G / JG;
    return Math.trunc(X);
  }
  function OZ(G) {
    const X = G / ZK;
    return Math.trunc(X);
  }
  function SZ(G) {
    const X = G / hK;
    return Math.trunc(X);
  }
  function yZ(G) {
    return Math.trunc(G * JG);
  }
  function kZ(G) {
    return Math.trunc(G * jK);
  }
  function hZ(G) {
    const X = G / mK;
    return Math.trunc(X);
  }
  function mZ(G) {
    const X = G / gK;
    return Math.trunc(X);
  }
  function NG(G, X) {
    let K = X - oG(G);
    if (K <= 0) K += 7;
    return u(G, K);
  }
  function gZ(G) {
    return NG(G, 5);
  }
  function cZ(G) {
    return NG(G, 1);
  }
  function fZ(G) {
    return NG(G, 6);
  }
  function pZ(G) {
    return NG(G, 0);
  }
  function uZ(G) {
    return NG(G, 4);
  }
  function _Z(G) {
    return NG(G, 2);
  }
  function lZ(G) {
    return NG(G, 3);
  }
  function dZ(G, X) {
    let K;
    const B =
      (K = X === null || X === void 0 ? void 0 : X.additionalDigits) !== null &&
      K !== void 0
        ? K
        : 2;
    const U = iZ(G);
    let Z;
    if (U.date) {
      const j = sZ(U.date, B);
      Z = nZ(j.restDateString, j.year);
    }
    if (!Z || isNaN(Z.getTime())) return new Date(NaN);
    const J = Z.getTime();
    let Q = 0;
    let H;
    if (U.time) {
      if (((Q = rZ(U.time)), isNaN(Q))) return new Date(NaN);
    }
    if (U.timezone) {
      if (((H = oZ(U.timezone)), isNaN(H))) return new Date(NaN);
    } else {
      const x = new Date(J + Q);
      const A = new Date(0);
      return (
        A.setFullYear(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate()),
        A.setHours(
          x.getUTCHours(),
          x.getUTCMinutes(),
          x.getUTCSeconds(),
          x.getUTCMilliseconds(),
        ),
        A
      );
    }
    return new Date(J + Q + H);
  }
  var iZ = function G(X) {
    const K = {};
    const B = X.split(GK.dateTimeDelimiter);
    let U;
    if (B.length > 2) return K;
    if (/:/.test(B[0])) U = B[0];
    else if (((K.date = B[0]), (U = B[1]), GK.timeZoneDelimiter.test(K.date)))
      (K.date = X.split(GK.timeZoneDelimiter)[0]),
        (U = X.substr(K.date.length, X.length));
    if (U) {
      const Z = GK.timezone.exec(U);
      if (Z) (K.time = U.replace(Z[1], "")), (K.timezone = Z[1]);
      else K.time = U;
    }
    return K;
  };
  var sZ = function G(X, K) {
    const B = new RegExp(
      `^(?:(\\d{4}|[+-]\\d{${4 + K}})|(\\d{2}|[+-]\\d{${2 + K}})$)`,
    );
    const U = X.match(B);
    if (!U) return { year: NaN, restDateString: "" };
    const Z = U[1] ? parseInt(U[1]) : null;
    const j = U[2] ? parseInt(U[2]) : null;
    return {
      year: j === null ? Z : j * 100,
      restDateString: X.slice((U[1] || U[2]).length),
    };
  };
  var nZ = function G(X, K) {
    if (K === null) return new Date(NaN);
    const B = X.match(Bj);
    if (!B) return new Date(NaN);
    const U = !!B[4];
    const Z = OG(B[1]);
    const j = OG(B[2]) - 1;
    const J = OG(B[3]);
    const Q = OG(B[4]);
    const H = OG(B[5]) - 1;
    if (U) {
      if (!Gj(K, Q, H)) return new Date(NaN);
      return aZ(K, Q, H);
    } else {
      const x = new Date(0);
      if (!eZ(K, j, J) || !tZ(K, Z)) return new Date(NaN);
      return x.setUTCFullYear(K, j, Math.max(Z, J)), x;
    }
  };
  var OG = function G(X) {
    return X ? parseInt(X) : 1;
  };
  var rZ = function G(X) {
    const K = X.match(Uj);
    if (!K) return NaN;
    const B = LK(K[1]);
    const U = LK(K[2]);
    const Z = LK(K[3]);
    if (!Kj(B, U, Z)) return NaN;
    return B * CG + U * JG + Z * 1000;
  };
  var LK = function G(X) {
    return (X && parseFloat(X.replace(",", "."))) || 0;
  };
  var oZ = function G(X) {
    if (X === "Z") return 0;
    const K = X.match(Zj);
    if (!K) return 0;
    const B = K[1] === "+" ? -1 : 1;
    const U = parseInt(K[2]);
    const Z = (K[3] && parseInt(K[3])) || 0;
    if (!Xj(U, Z)) return NaN;
    return B * (U * CG + Z * JG);
  };
  var aZ = function G(X, K, B) {
    const U = new Date(0);
    U.setUTCFullYear(X, 0, 4);
    const Z = U.getUTCDay() || 7;
    const j = (K - 1) * 7 + B + 1 - Z;
    return U.setUTCDate(U.getUTCDate() + j), U;
  };
  const mX = function G(X) {
    return X % 400 === 0 || (X % 4 === 0 && X % 100 !== 0);
  };
  var eZ = function G(X, K, B) {
    return K >= 0 && K <= 11 && B >= 1 && B <= (jj[K] || (mX(X) ? 29 : 28));
  };
  var tZ = function G(X, K) {
    return K >= 1 && K <= (mX(X) ? 366 : 365);
  };
  var Gj = function G(X, K, B) {
    return K >= 1 && K <= 53 && B >= 0 && B <= 6;
  };
  var Kj = function G(X, K, B) {
    if (X === 24) return K === 0 && B === 0;
    return B >= 0 && B < 60 && K >= 0 && K < 60 && X >= 0 && X < 25;
  };
  var Xj = function G(X, K) {
    return K >= 0 && K <= 59;
  };
  var GK = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/,
  };
  var Bj = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
  var Uj =
    /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
  var Zj = /^([+-])(\d{2})(?::?(\d{2}))?$/;
  var jj = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function Jj(G) {
    const X = G.match(
      /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/,
    );
    if (X)
      return new Date(
        Date.UTC(
          +X[1],
          +X[2] - 1,
          +X[3],
          +X[4] - (+X[9] || 0) * (X[8] == "-" ? -1 : 1),
          +X[5] - (+X[10] || 0) * (X[8] == "-" ? -1 : 1),
          +X[6],
          +`${X[7] || "0"}00`.substring(0, 3),
        ),
      );
    return new Date(NaN);
  }
  function VG(G, X) {
    let K = oG(G) - X;
    if (K <= 0) K += 7;
    return tG(G, K);
  }
  function qj(G) {
    return VG(G, 5);
  }
  function Qj(G) {
    return VG(G, 1);
  }
  function Hj(G) {
    return VG(G, 6);
  }
  function xj(G) {
    return VG(G, 0);
  }
  function Aj(G) {
    return VG(G, 4);
  }
  function Nj(G) {
    return VG(G, 2);
  }
  function Vj(G) {
    return VG(G, 3);
  }
  function Ej(G) {
    return Math.trunc(G * mK);
  }
  function Fj(G) {
    const X = G / cK;
    return Math.trunc(X);
  }
  function Cj(G, X) {
    let K;
    let B;
    const U =
      (K = X === null || X === void 0 ? void 0 : X.nearestTo) !== null &&
      K !== void 0
        ? K
        : 1;
    if (U < 1 || U > 12) return M(G, NaN);
    const Z = q(G);
    const j = Z.getMinutes() / 60;
    const J = Z.getSeconds() / 60 / 60;
    const Q = Z.getMilliseconds() / 1000 / 60 / 60;
    const H = Z.getHours() + j + J + Q;
    const x =
      (B = X === null || X === void 0 ? void 0 : X.roundingMethod) !== null &&
      B !== void 0
        ? B
        : "round";
    const A = AG(x);
    const E = A(H / U) * U;
    const T = M(G, Z);
    return T.setHours(E, 0, 0, 0), T;
  }
  function wj(G, X) {
    let K;
    let B;
    const U =
      (K = X === null || X === void 0 ? void 0 : X.nearestTo) !== null &&
      K !== void 0
        ? K
        : 1;
    if (U < 1 || U > 30) return M(G, NaN);
    const Z = q(G);
    const j = Z.getSeconds() / 60;
    const J = Z.getMilliseconds() / 1000 / 60;
    const Q = Z.getMinutes() + j + J;
    const H =
      (B = X === null || X === void 0 ? void 0 : X.roundingMethod) !== null &&
      B !== void 0
        ? B
        : "round";
    const x = AG(H);
    const A = x(Q / U) * U;
    const E = M(G, Z);
    return E.setMinutes(A, 0, 0), E;
  }
  function Ij(G) {
    const X = G / hG;
    return Math.trunc(X);
  }
  function bj(G) {
    return G * ZK;
  }
  function Mj(G) {
    const X = G / jK;
    return Math.trunc(X);
  }
  function $K(G, X) {
    const K = q(G);
    const B = K.getFullYear();
    const U = K.getDate();
    const Z = M(G, 0);
    Z.setFullYear(B, X, 15), Z.setHours(0, 0, 0, 0);
    const j = VX(Z);
    return K.setMonth(X, Math.min(U, j)), K;
  }
  function Yj(G, X) {
    let K = q(G);
    if (isNaN(+K)) return M(G, NaN);
    if (X.year != null) K.setFullYear(X.year);
    if (X.month != null) K = $K(K, X.month);
    if (X.date != null) K.setDate(X.date);
    if (X.hours != null) K.setHours(X.hours);
    if (X.minutes != null) K.setMinutes(X.minutes);
    if (X.seconds != null) K.setSeconds(X.seconds);
    if (X.milliseconds != null) K.setMilliseconds(X.milliseconds);
    return K;
  }
  function Tj(G, X) {
    const K = q(G);
    return K.setDate(X), K;
  }
  function zj(G, X) {
    const K = q(G);
    return K.setMonth(0), K.setDate(X), K;
  }
  function Wj(G) {
    const X = {};
    const K = _();
    for (const B in K)
      if (Object.prototype.hasOwnProperty.call(K, B)) X[B] = K[B];
    for (const U in G)
      if (Object.prototype.hasOwnProperty.call(G, U))
        if (G[U] === void 0) delete X[U];
        else X[U] = G[U];
    B0(X);
  }
  function Rj(G, X) {
    const K = q(G);
    return K.setHours(X), K;
  }
  function Lj(G, X) {
    const K = q(G);
    return K.setMilliseconds(X), K;
  }
  function $j(G, X) {
    const K = q(G);
    return K.setMinutes(X), K;
  }
  function Pj(G, X) {
    const K = q(G);
    const B = Math.trunc(K.getMonth() / 3) + 1;
    const U = X - B;
    return $K(K, K.getMonth() + U * 3);
  }
  function Dj(G, X) {
    const K = q(G);
    return K.setSeconds(X), K;
  }
  function vj(G, X, K) {
    let B;
    let U;
    let Z;
    let j;
    let J;
    let Q;
    const H = _();
    const x =
      (B =
        (U =
          (Z =
            (j =
              K === null || K === void 0 ? void 0 : K.firstWeekContainsDate) !==
              null && j !== void 0
              ? j
              : K === null ||
                  K === void 0 ||
                  (J = K.locale) === null ||
                  J === void 0 ||
                  (J = J.options) === null ||
                  J === void 0
                ? void 0
                : J.firstWeekContainsDate) !== null && Z !== void 0
            ? Z
            : H.firstWeekContainsDate) !== null && U !== void 0
          ? U
          : (Q = H.locale) === null ||
              Q === void 0 ||
              (Q = Q.options) === null ||
              Q === void 0
            ? void 0
            : Q.firstWeekContainsDate) !== null && B !== void 0
        ? B
        : 1;
    let A = q(G);
    const E = KG(A, nG(A, K));
    const T = M(G, 0);
    return (
      T.setFullYear(X, 0, x),
      T.setHours(0, 0, 0, 0),
      (A = nG(T, K)),
      A.setDate(A.getDate() + E),
      A
    );
  }
  function Oj(G, X) {
    const K = q(G);
    if (isNaN(+K)) return M(G, NaN);
    return K.setFullYear(X), K;
  }
  function Sj(G) {
    const X = q(G);
    const K = X.getFullYear();
    const B = Math.floor(K / 10) * 10;
    return X.setFullYear(B, 0, 1), X.setHours(0, 0, 0, 0), X;
  }
  function yj() {
    return MG(Date.now());
  }
  function kj() {
    const G = new Date();
    const X = G.getFullYear();
    const K = G.getMonth();
    const B = G.getDate();
    const U = new Date(0);
    return U.setFullYear(X, K, B + 1), U.setHours(0, 0, 0, 0), U;
  }
  function hj() {
    const G = new Date();
    const X = G.getFullYear();
    const K = G.getMonth();
    const B = G.getDate();
    const U = new Date(0);
    return U.setFullYear(X, K, B - 1), U.setHours(0, 0, 0, 0), U;
  }
  function gX(G, X) {
    return a(G, -X);
  }
  function mj(G, X) {
    const K = X.years;
    const B = K === void 0 ? 0 : K;
    const U = X.months;
    const Z = U === void 0 ? 0 : U;
    const j = X.weeks;
    const J = j === void 0 ? 0 : j;
    const Q = X.days;
    const H = Q === void 0 ? 0 : Q;
    const x = X.hours;
    const A = x === void 0 ? 0 : x;
    const E = X.minutes;
    const T = E === void 0 ? 0 : E;
    const I = X.seconds;
    const z = I === void 0 ? 0 : I;
    const Y = gX(G, Z + B * 12);
    const W = tG(Y, H + J * 7);
    const R = T + A * 60;
    const m = z + R * 60;
    const l = m * 1000;
    const r = M(G, W.getTime() - l);
    return r;
  }
  function gj(G, X) {
    return OK(G, -X);
  }
  function cj(G, X) {
    return qK(G, -X);
  }
  function fj(G, X) {
    return RG(G, -X);
  }
  function pj(G, X) {
    return QK(G, -X);
  }
  function uj(G, X) {
    return HK(G, -X);
  }
  function _j(G, X) {
    return dK(G, -X);
  }
  function lj(G, X) {
    return mG(G, -X);
  }
  function dj(G, X) {
    return iK(G, -X);
  }
  function ij(G) {
    return Math.trunc(G * SK);
  }
  function sj(G) {
    return Math.trunc(G * yG);
  }
  function nj(G) {
    return Math.trunc(G * gK);
  }
  function rj(G) {
    return Math.trunc(G * cK);
  }
  window.dateFns = sX(sX({}, window.dateFns), w);
})();
/* eslint-enable */
